/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface AccountingTableContractsDto {
  id?: string | null;
  /** @format int32 */
  contractId?: number;
  /** @format int32 */
  brokerHouseId?: number;
  brokerHouseName?: string | null;
  /** @format int32 */
  contractNumber?: number;
  number?: string | null;
  registeredOn?: DateOnly;
  offerName?: string | null;
  /** @format double */
  totalPrice?: number;
  /** @format double */
  commission?: number;
  invoiceNumber?: string | null;
  /** @format int32 */
  isPaid?: number;
  isBuy?: boolean;
  code?: string | null;
  issueDate?: DateOnly;
  paidDate?: DateOnly;
  note?: string | null;
}

export interface AuditDto {
  /** @format date-time */
  date?: string | null;
  oldValues?: string | null;
  newValues?: string | null;
}

export interface BidDto {
  /** @format int32 */
  id?: number;
  /** @format int32 */
  brokerId?: number | null;
  brokerCode?: string | null;
  isBuy?: boolean;
  /** @format double */
  price?: number;
  /** @format double */
  netQuantity?: number | null;
  /** @format int32 */
  measurementId?: number;
  measurement?: string | null;
}

export interface BidEntity {
  /** @format int32 */
  id?: number;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format date-time */
  deletedAt?: string | null;
  /** @format int32 */
  brokerId?: number | null;
  /** @format int32 */
  offerId?: number;
  /** @format int32 */
  isBuy?: number;
  /** @format double */
  price?: number;
  /** @format int32 */
  measurementId?: number;
  /** @format double */
  netQuantity?: number | null;
  /** @format int32 */
  dealId?: number | null;
  /** @format int32 */
  exchangeSessionId?: number | null;
  /** @format int32 */
  oldId?: number | null;
  /** @format int32 */
  forDealId?: number | null;
  measurement?: MeasurementEntity;
  broker?: BrokerEntity;
  deal?: DealEntity;
  exchangeSession?: ExchangeSessionEntity;
  forDeal?: DealEntity;
  offer?: OfferEntity;
}

export interface BrokerDto {
  /** @format int32 */
  id?: number;
  /** @format int32 */
  brokerHouseId?: number;
  name?: string | null;
  middleName?: string | null;
  code?: string | null;
  phone?: string | null;
  fax?: string | null;
  email?: string | null;
  egn?: string | null;
  cardNumber?: string | null;
  homeAddress?: string | null;
  homePhone?: string | null;
  officeAddress?: string | null;
  officePhone?: string | null;
  docPermissionDksbt?: string | null;
  docBrokerCertificate?: string | null;
  ssbRegistryPage?: string | null;
  docPreReregistrationDksbt?: string | null;
  notes?: string | null;
  /** @format int32 */
  active?: number;
}

export interface BrokerDtoLazyResponse {
  rows?: BrokerDto[] | null;
  /** @format int32 */
  totalRecords?: number;
}

export interface BrokerEntity {
  /** @format int32 */
  id?: number;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format date-time */
  deletedAt?: string | null;
  /** @format int32 */
  brokerHouseId?: number;
  name?: string | null;
  middleName?: string | null;
  code?: string | null;
  phone?: string | null;
  fax?: string | null;
  email?: string | null;
  egn?: string | null;
  cardNumber?: string | null;
  homeAddress?: string | null;
  homePhone?: string | null;
  officeAddress?: string | null;
  officePhone?: string | null;
  docPermissionDksbt?: string | null;
  docBrokerCertificate?: string | null;
  ssbRegistryPage?: string | null;
  docPreReregistrationDksbt?: string | null;
  notes?: string | null;
  /** @format int32 */
  active?: number;
  /** @format int32 */
  oldId?: number | null;
  bids?: BidEntity[] | null;
  brokerHouse?: BrokerHouseEntity;
  dealBuyBrokers?: DealEntity[] | null;
  dealSaleBrokers?: DealEntity[] | null;
  exchangeSessionBrokers?: ExchangeSessionBrokerEntity[] | null;
  offerBuyBrokers?: OfferEntity[] | null;
  offerSaleBrokers?: OfferEntity[] | null;
  offerSubmittedByBrokers?: OfferEntity[] | null;
}

export interface BrokerHouseDto {
  /** @format int32 */
  id?: number;
  name?: string | null;
  code?: string | null;
  /** @format int32 */
  brokerHouseMembershipId?: number | null;
  phone?: string | null;
  fax?: string | null;
  email?: string | null;
  eik?: string | null;
  taxNumber?: string | null;
  documentNumber?: string | null;
  registryNumber?: string | null;
  subscribedAt?: DateOnly;
  unsubscribedAt?: DateOnly;
  postCode?: string | null;
  city?: string | null;
  address?: string | null;
  correspondenceAddress?: string | null;
  person?: string | null;
  personPosition?: string | null;
  subscriptionNote?: string | null;
  unsubscriptionNote?: string | null;
  notes?: string | null;
  history?: string | null;
  /** @format int32 */
  status?: number | null;
  /** @format int32 */
  activity?: number | null;
}

export interface BrokerHouseDtoLazyResponse {
  rows?: BrokerHouseDto[] | null;
  /** @format int32 */
  totalRecords?: number;
}

export interface BrokerHouseEntity {
  /** @format int32 */
  id?: number;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format date-time */
  deletedAt?: string | null;
  name?: string | null;
  code?: string | null;
  /** @format int32 */
  regionalCenterId?: number | null;
  /** @format int32 */
  brokerHouseMembershipId?: number | null;
  phone?: string | null;
  fax?: string | null;
  email?: string | null;
  eik?: string | null;
  taxNumber?: string | null;
  documentNumber?: string | null;
  registryNumber?: string | null;
  subscribedAt?: DateOnly;
  unsubscribedAt?: DateOnly;
  postCode?: string | null;
  city?: string | null;
  address?: string | null;
  correspondenceAddress?: string | null;
  person?: string | null;
  personPosition?: string | null;
  subscriptionNote?: string | null;
  unsubscriptionNote?: string | null;
  notes?: string | null;
  history?: string | null;
  /** @format int32 */
  status?: number | null;
  /** @format int32 */
  activity?: number | null;
  /** @format int32 */
  oldId?: number | null;
  oldDbTable?: string | null;
  brokerHouseMembership?: BrokerHouseMembershipEntity;
  brokerHouseFreezes?: BrokerHouseFreezeEntity[] | null;
  brokerHousePayments?: BrokerHousePaymentEntity[] | null;
  brokerHouseWarnings?: BrokerHouseWarningEntity[] | null;
  brokers?: BrokerEntity[] | null;
  dealBuyBrokerHouses?: DealEntity[] | null;
  dealSaleBrokerHouses?: DealEntity[] | null;
  regionalCenter?: RegionalCenterEntity;
}

export interface BrokerHouseFreezeEntity {
  /** @format int32 */
  id?: number;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format date-time */
  deletedAt?: string | null;
  /** @format int32 */
  brokerHouseId?: number;
  /** @format int32 */
  active?: number;
  from?: DateOnly;
  to?: DateOnly;
  notes?: string | null;
  /** @format int32 */
  oldId?: number | null;
  brokerHouse?: BrokerHouseEntity;
}

export interface BrokerHouseMembershipEntity {
  /** @format int32 */
  id?: number;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format date-time */
  deletedAt?: string | null;
  name?: string | null;
  /** @format int32 */
  oldId?: number | null;
  brokerHouses?: BrokerHouseEntity[] | null;
}

export interface BrokerHousePaymentDto {
  /** @format int32 */
  id?: number;
  /** @format int32 */
  brokerHouseId?: number;
  /** @format int32 */
  paidFirst?: number | null;
  /** @format int32 */
  paidSecond?: number | null;
  /** @format int32 */
  paidPartially?: number | null;
  firstNotes?: string | null;
  partiallyNotes?: string | null;
  year?: string | null;
  secondNotes?: string | null;
}

export interface BrokerHousePaymentDtoLazyResponse {
  rows?: BrokerHousePaymentDto[] | null;
  /** @format int32 */
  totalRecords?: number;
}

export interface BrokerHousePaymentEntity {
  /** @format int32 */
  id?: number;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format date-time */
  deletedAt?: string | null;
  /** @format int32 */
  brokerHouseId?: number;
  /** @format int32 */
  paidFirst?: number | null;
  /** @format int32 */
  paidSecond?: number | null;
  /** @format int32 */
  paidPartially?: number | null;
  /** @format int32 */
  new?: number | null;
  firstNotes?: string | null;
  partiallyNotes?: string | null;
  year?: string | null;
  controlDate?: DateOnly;
  secondNotes?: string | null;
  /** @format int32 */
  oldId?: number | null;
  brokerHouse?: BrokerHouseEntity;
}

export interface BrokerHouseReportDto {
  brokerHouseCode?: string | null;
  brokerHouseName?: string | null;
  paidFirst?: string | null;
  firstNotes?: string | null;
  paidSecond?: string | null;
  secondNotes?: string | null;
  paidPartially?: string | null;
  partiallyNotes?: string | null;
  year?: string | null;
}

export interface BrokerHouseReportDtoLazyResponse {
  rows?: BrokerHouseReportDto[] | null;
  /** @format int32 */
  totalRecords?: number;
}

export interface BrokerHouseWarningEntity {
  /** @format int32 */
  id?: number;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format date-time */
  deletedAt?: string | null;
  /** @format int32 */
  brokerHouseId?: number;
  /** @format date-time */
  documentDate?: string | null;
  document?: string | null;
  warning?: string | null;
  /** @format int32 */
  oldId?: number | null;
  brokerHouse?: BrokerHouseEntity;
}

export interface BrokerOfferCommodityDto {
  /** @format int32 */
  commodityId?: number | null;
  /** @format int32 */
  measurementId?: number | null;
  /** @format double */
  quantity?: number | null;
  notes?: string | null;
  /** @format int32 */
  id?: number | null;
}

export interface BrokerOfferDto {
  /** @format int32 */
  id?: number | null;
  /** @format int32 */
  exchangeCircleId?: number | null;
  /** @format int32 */
  offerTypeId?: number;
  offerTypeShortName?: string | null;
  name?: string | null;
  nsiCode?: string | null;
  /** @format date-time */
  registeredAt?: string | null;
  /** @format date-time */
  dateRegister?: string | null;
  expireOn?: DateOnly;
  /** @format int32 */
  isBuy?: number;
  /** @format int32 */
  submittedByBrokerId?: number | null;
  notes?: string | null;
  /** @format int32 */
  currencyId?: number | null;
  /** @format double */
  startPrice?: number | null;
  vatIncluded?: boolean;
  /** @format double */
  netQuantity?: number | null;
  /** @format int32 */
  measurementId?: number | null;
  /** @format int32 */
  startContractsCount?: number | null;
  place?: string | null;
  deliveryTime?: string | null;
  /** @format int32 */
  deliveryTimeId?: number | null;
  /** @format int32 */
  approved?: number;
  /** @format int32 */
  cpvCodeId?: number | null;
  currencyName?: string | null;
  rejectionReason?: string | null;
  offerCommodities?: BrokerOfferCommodityDto[] | null;
}

export interface BrokerOfferForApprovalTableResultDto {
  data?: Record<string, BrokerOfferTableDto[]>;
}

export interface BrokerOfferTableDto {
  /** @format int32 */
  offerId?: number | null;
  /** @format int32 */
  brokerOfferId?: number | null;
  /** @format int32 */
  exchangeCircleId?: number | null;
  /** @format int32 */
  offerTypeId?: number;
  name?: string | null;
  /** @format date-time */
  registeredAt?: string | null;
  expireOn?: DateOnly;
  /** @format double */
  startPrice?: number | null;
  /** @format double */
  netQuantity?: number | null;
  measurementId?: string | null;
  /** @format int32 */
  startContractsCount?: number | null;
  deliveryTimeId?: string | null;
  status?: string | null;
  offerTypeShortName?: string | null;
  number?: string | null;
  place?: string | null;
  submittedByBroker?: string | null;
}

export interface BrokerOfferTableDtoLazyResponse {
  rows?: BrokerOfferTableDto[] | null;
  /** @format int32 */
  totalRecords?: number;
}

export interface BrokerReportDto {
  active?: string | null;
  name?: string | null;
  code?: string | null;
  brokerHouseName?: string | null;
}

export interface BrokerReportDtoLazyResponse {
  rows?: BrokerReportDto[] | null;
  /** @format int32 */
  totalRecords?: number;
}

export interface BrokerSessionDto {
  /** @format int32 */
  id?: number;
  /** @format int32 */
  userId?: number;
  name?: string | null;
  code?: string | null;
}

export interface BrokerSummaryDto {
  /** @format int32 */
  id?: number;
  name?: string | null;
  code?: string | null;
}

export interface BrokerUserDto {
  /** @format int32 */
  userId?: number;
  /** @format int32 */
  brokerId?: number;
  username?: string | null;
  email?: string | null;
  brokerCode?: string | null;
  name?: string | null;
  brokerHouseName?: string | null;
}

export interface BrokersToOnlineOfferDto {
  offer?: OfferSummaryDto;
  brokers?: BrokerSummaryDto[] | null;
}

export interface ChangePasswordRequestDto {
  username?: string | null;
  oldPassword?: string | null;
  newPassword?: string | null;
}

export interface CommissionDto {
  /** @format int32 */
  id?: number;
  /** @format double */
  from?: number | null;
  /** @format double */
  to?: number | null;
  /** @format double */
  tax?: number;
  /** @format int32 */
  type?: number;
  /** @format int32 */
  active?: number;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string | null;
}

export interface CommissionDtoLazyResponse {
  rows?: CommissionDto[] | null;
  /** @format int32 */
  totalRecords?: number;
}

export interface CommodityDto {
  /** @format int32 */
  id?: number;
  name?: string | null;
  nsiCode?: string | null;
  kopCode?: string | null;
  /** @format int32 */
  measurementId?: number;
  /** @format int32 */
  exchangeCircleId?: number;
  exchangeFromDate?: DateOnly;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
}

export interface CommodityDtoLazyResponse {
  rows?: CommodityDto[] | null;
  /** @format int32 */
  totalRecords?: number;
}

export interface CommodityEntity {
  /** @format int32 */
  id?: number;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format date-time */
  deletedAt?: string | null;
  name?: string | null;
  nsiCode?: string | null;
  kopCode?: string | null;
  /** @format int32 */
  measurementId?: number;
  /** @format int32 */
  exchangeCircleId?: number;
  exchangeFromDate?: DateOnly;
  /** @format int32 */
  oldId?: number | null;
  exchangeCircle?: ExchangeCircleEntity;
  measurement?: MeasurementEntity;
  offerCommodities?: OfferCommodityEntity[] | null;
}

export interface CommodityGroupEntity {
  /** @format int32 */
  id?: number;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format date-time */
  deletedAt?: string | null;
  /** @format int32 */
  exchangeCircleId?: number;
  name?: string | null;
  /** @format int32 */
  order?: number;
  /** @format int32 */
  oldId?: number | null;
  exchangeCircle?: ExchangeCircleEntity;
}

export interface CompanyContractDto {
  id?: string | null;
  registeredOn?: DateOnly;
  offerName?: string | null;
  buyerName?: string | null;
  sellerName?: string | null;
}

export interface CompanyContractsDto {
  buyContracts?: CompanyContractDto[] | null;
  saleContracts?: CompanyContractDto[] | null;
}

export interface CompanyDto {
  /** @format int32 */
  id?: number;
  /** @format int32 */
  instituteId?: number | null;
  name?: string | null;
  phone?: string | null;
  fax?: string | null;
  eik?: string | null;
  taxNumber?: string | null;
  city?: string | null;
  address?: string | null;
  correspondenceAddress?: string | null;
  person?: string | null;
  notes?: string | null;
  /** @format int32 */
  contractBuyCount?: number;
  /** @format int32 */
  contractSellCount?: number;
}

export interface CompanyDtoLazyResponse {
  rows?: CompanyDto[] | null;
  /** @format int32 */
  totalRecords?: number;
}

export interface CompanyEntity {
  /** @format int32 */
  id?: number;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format date-time */
  deletedAt?: string | null;
  /** @format int32 */
  instituteId?: number | null;
  name?: string | null;
  phone?: string | null;
  fax?: string | null;
  eik?: string | null;
  taxNumber?: string | null;
  city?: string | null;
  address?: string | null;
  correspondenceAddress?: string | null;
  person?: string | null;
  notes?: string | null;
  /** @format int32 */
  oldId?: number | null;
  contractBuyCompanies?: ContractEntity[] | null;
  contractSellCompanies?: ContractEntity[] | null;
  institute?: InstituteEntity;
}

export interface ContractDealEntity {
  /** @format int32 */
  contractId?: number;
  /** @format int32 */
  dealId?: number;
  /** @format int32 */
  oldId?: number | null;
  contract?: ContractEntity;
  deal?: DealEntity;
}

export type ContractDto = object;

export interface ContractEntity {
  /** @format int32 */
  id?: number;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format date-time */
  deletedAt?: string | null;
  /** @format int32 */
  numberInYear?: number;
  registeredOn?: DateOnly;
  commodities?: string | null;
  offerTypeShortName?: string | null;
  stateReserve?: string | null;
  /** @format double */
  paidDeposit1?: number | null;
  /** @format double */
  paidDeposit2?: number | null;
  notes?: string | null;
  /** @format int32 */
  sellCompanyId?: number | null;
  /** @format int32 */
  buyCompanyId?: number | null;
  /** @format int32 */
  isCanceled?: number;
  /** @format double */
  commission?: number;
  sellerInvoice?: string | null;
  /** @format int32 */
  sellerIsPaid?: number;
  sellerIssueDate?: DateOnly;
  sellerPaidDate?: DateOnly;
  sellerNote?: string | null;
  buyerInvoice?: string | null;
  /** @format int32 */
  buyerIsPaid?: number;
  buyerIssueDate?: DateOnly;
  buyerPaidDate?: DateOnly;
  buyerNote?: string | null;
  /** @format double */
  totalPrice?: number;
  /** @format double */
  totalQuantity?: number;
  number?: string | null;
  /** @format int32 */
  oldId?: number | null;
  expireAt?: DateOnly;
  buyCompany?: CompanyEntity;
  sellCompany?: CompanyEntity;
  contractTickets?: ContractTicketEntity[] | null;
  contractOfferCommodities?: ContractOfferCommodityEntity[] | null;
  contractDeals?: ContractDealEntity[] | null;
}

export interface ContractOfferCommodityEntity {
  /** @format int32 */
  id?: number;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format date-time */
  deletedAt?: string | null;
  /** @format int32 */
  contractId?: number;
  /** @format int32 */
  offerCommodityId?: number;
  /** @format double */
  quantity?: number;
  /** @format double */
  price?: number;
  notes?: string | null;
  /** @format int32 */
  measurementId?: number | null;
  contract?: ContractEntity;
  measurement?: MeasurementEntity;
  offerCommodity?: OfferCommodityEntity;
}

export interface ContractReportDto {
  offerNumber?: string | null;
  /** @format int32 */
  id?: number;
  number?: string | null;
  registeredOn?: string | null;
  expireAt?: string | null;
  offerType?: string | null;
  offerName?: string | null;
  /** @format double */
  quantity?: number;
  measurement?: string | null;
  /** @format double */
  price?: number;
  currencyWithMeasurement?: string | null;
  /** @format double */
  totalPrice?: number;
  /** @format double */
  totalQuantity?: number;
  ticketNumbers?: string | null;
  sellBroker?: string | null;
  buyBroker?: string | null;
  sellBrokerHouse?: string | null;
  buyBrokerHouse?: string | null;
  sellCompany?: string | null;
  buyCompany?: string | null;
}

export interface ContractReportDtoLazyResponse {
  rows?: ContractReportDto[] | null;
  /** @format int32 */
  totalRecords?: number;
}

export interface ContractTicketEntity {
  /** @format int32 */
  contractId?: number;
  /** @format int32 */
  ticketId?: number;
  /** @format int32 */
  oldId?: number | null;
  contract?: ContractEntity;
  ticket?: TicketEntity;
}

export interface CpvCodeDto {
  /** @format int32 */
  id?: number;
  name?: string | null;
  code?: string | null;
}

export interface CpvCodeDtoLazyResponse {
  rows?: CpvCodeDto[] | null;
  /** @format int32 */
  totalRecords?: number;
}

export interface CpvCodeEntity {
  /** @format int32 */
  id?: number;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format date-time */
  deletedAt?: string | null;
  name?: string | null;
  code?: string | null;
  /** @format int32 */
  oldId?: number | null;
  offers?: OfferEntity[] | null;
}

export interface CreateBidDto {
  isBuy?: boolean | null;
  /** @format double */
  price?: number | null;
  /** @format double */
  netQuantity?: number | null;
  /** @format int32 */
  brokerId?: number | null;
}

export interface CreateBrokerBidDto {
  /** @format double */
  price?: number | null;
  /** @format double */
  netQuantity?: number | null;
}

export interface CreateBrokerDto {
  /** @format int32 */
  brokerHouseId?: number | null;
  name?: string | null;
  middleName?: string | null;
  code?: string | null;
  phone?: string | null;
  fax?: string | null;
  email?: string | null;
  egn?: string | null;
  cardNumber?: string | null;
  homeAddress?: string | null;
  homePhone?: string | null;
  officeAddress?: string | null;
  officePhone?: string | null;
  docPermissionDksbt?: string | null;
  docBrokerCertificate?: string | null;
  ssbRegistryPage?: string | null;
  docPreReregistrationDksbt?: string | null;
  notes?: string | null;
  /** @format int32 */
  active?: number;
}

export interface CreateBrokerHouseDto {
  name?: string | null;
  code?: string | null;
  /** @format int32 */
  brokerHouseMembershipId?: number | null;
  phone?: string | null;
  fax?: string | null;
  email?: string | null;
  eik?: string | null;
  taxNumber?: string | null;
  documentNumber?: string | null;
  registryNumber?: string | null;
  subscribedAt?: DateOnly;
  unsubscribedAt?: DateOnly;
  postCode?: string | null;
  city?: string | null;
  address?: string | null;
  correspondenceAddress?: string | null;
  person?: string | null;
  personPosition?: string | null;
  subscriptionNote?: string | null;
  unsubscriptionNote?: string | null;
  notes?: string | null;
  /** @format int32 */
  activity?: number | null;
}

export interface CreateBrokerHousePaymentDto {
  /** @format int32 */
  brokerHouseId?: number;
  /** @format int32 */
  paidFirst?: number | null;
  /** @format int32 */
  paidSecond?: number | null;
  /** @format int32 */
  paidPartially?: number | null;
  firstNotes?: string | null;
  partiallyNotes?: string | null;
  year?: string | null;
  secondNotes?: string | null;
}

export interface CreateBrokerOfferCommodityDto {
  /** @format int32 */
  commodityId?: number | null;
  /** @format int32 */
  measurementId?: number | null;
  /** @format double */
  quantity?: number | null;
  notes?: string | null;
}

export interface CreateBrokerOfferDto {
  /** @format int32 */
  exchangeCircleId?: number | null;
  /** @format int32 */
  offerTypeId?: number;
  name?: string | null;
  /** @format int32 */
  nsiCodeId?: number | null;
  /** @format double */
  netQuantity?: number | null;
  /** @format int32 */
  measurementId?: number | null;
  /** @format int32 */
  startContractsCount?: number | null;
  place?: string | null;
  /** @format int32 */
  deliveryTimeId?: number | null;
  /** @format double */
  startPrice?: number | null;
  vatIncluded?: boolean;
  /** @format int32 */
  currencyId?: number | null;
  expireOn?: DateOnly;
  /** @format int32 */
  submittedByBrokerId?: number | null;
  /** @format date-time */
  registeredAt?: string | null;
  /** @format date-time */
  dateRegister?: string | null;
  /** @format int32 */
  cpvCodeId?: number | null;
  notes?: string | null;
  offerCommodities?: CreateBrokerOfferCommodityDto[] | null;
}

export interface CreateCommissionDto {
  /** @format double */
  from?: number | null;
  /** @format double */
  to?: number | null;
  /** @format double */
  tax?: number;
  /** @format int32 */
  type?: number;
}

export interface CreateCommodityDto {
  name?: string | null;
  nsiCode?: string | null;
  /** @format int32 */
  measurementId?: number | null;
  /** @format int32 */
  exchangeCircleId?: number;
}

export interface CreateCompanyDto {
  /** @format int32 */
  instituteId?: number | null;
  name?: string | null;
  phone?: string | null;
  fax?: string | null;
  eik?: string | null;
  taxNumber?: string | null;
  city?: string | null;
  address?: string | null;
  correspondenceAddress?: string | null;
  person?: string | null;
  notes?: string | null;
}

export interface CreateContractWithCommodityDto {
  /** @format int32 */
  id?: number | null;
  registeredOn?: DateOnly;
  expireAt?: DateOnly;
  /** @format int32 */
  sellCompanyId?: number | null;
  /** @format int32 */
  buyCompanyId?: number | null;
  /** @format double */
  totalPrice?: number | null;
  /** @format double */
  totalQuantity?: number | null;
  number?: string | null;
  /** @format int32 */
  buyBrokerId?: number | null;
  /** @format int32 */
  saleBrokerId?: number | null;
  /** @format int32 */
  buyBrokerHouseId?: number | null;
  /** @format int32 */
  saleBrokerHouseId?: number | null;
  /** @format int32 */
  isCancelled?: number | null;
  ticketIds?: number[] | null;
  dealIds?: number[] | null;
  /** @format double */
  dealsTotalQuantity?: number;
  /** @format double */
  dealsTotalPrice?: number;
  commodities?: UpdateCommodityForContractDto[] | null;
}

export interface CreateContractWithCommodityRequest {
  contracts?: CreateContractWithCommodityDto[] | null;
}

export interface CreateCpvCodeDto {
  name?: string | null;
  code?: string | null;
}

export interface CreateDealWithCommodityDto {
  /** @format int32 */
  id?: number | null;
  dealDate?: DateOnly;
  /** @format int32 */
  saleBrokerId?: number | null;
  /** @format int32 */
  buyBrokerId?: number | null;
  /** @format double */
  quantity?: number | null;
  /** @format double */
  price?: number | null;
  currencyName?: string | null;
  /** @format int32 */
  offerId?: number | null;
  /** @format int32 */
  orderInOffer?: number;
  commodities?: UpdateCommodityForDealDto[] | null;
}

export interface CreateDealWithCommodityRequest {
  deals?: CreateDealWithCommodityDto[] | null;
}

export interface CreateDeliveryTimeDto {
  value?: string | null;
}

export interface CreateExchangeSessionDto {
  date?: DateOnly;
}

export interface CreateGuaranteeDepositDto {
  company?: string | null;
  contractNumber?: string | null;
  /** @format double */
  amount?: number | null;
  receivedDate?: DateOnly;
  returnedDate?: DateOnly;
  /** @format double */
  returnedAmount?: number | null;
  /** @format double */
  remainder?: number | null;
  note?: string | null;
}

export interface CreateMeasurementDto {
  name?: string | null;
  plural?: string | null;
  type?: string | null;
}

export interface CreateOfferCommodityDto {
  /** @format int32 */
  commodityId?: number | null;
  /** @format int32 */
  measurementId?: number | null;
  /** @format double */
  quantity?: number | null;
  notes?: string | null;
}

export interface CreateOfferDto {
  isUrgent?: boolean | null;
  /** @format int32 */
  exchangeCircleId?: number | null;
  /** @format int32 */
  offerTypeId?: number | null;
  name?: string | null;
  /** @format int32 */
  nsiCodeId?: number | null;
  /** @format double */
  netQuantity?: number | null;
  /** @format int32 */
  measurementId?: number | null;
  /** @format int32 */
  startContractsCount?: number | null;
  place?: string | null;
  /** @format int32 */
  deliveryTimeId?: number | null;
  /** @format double */
  startPrice?: number | null;
  vatIncluded?: boolean;
  /** @format int32 */
  currencyId?: number | null;
  expireOn?: DateOnly;
  /** @format int32 */
  submittedByBrokerId?: number | null;
  registeredAt?: DateOnly;
  /** @format date-time */
  dateRegister?: Date | null;
  /** @format int32 */
  cpvCodeId?: number | null;
  notes?: string | null;
  /** @format double */
  step?: number | null;
  offerCommodities?: CreateOfferCommodityDto[] | null;
}

export interface CreateUserDto {
  username?: string | null;
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  active?: boolean | null;
  /** @format int32 */
  roleId?: number | null;
  /** @format int32 */
  brokerId?: number | null;
}

export interface CurrencyEntity {
  /** @format int32 */
  id?: number;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format date-time */
  deletedAt?: string | null;
  name?: string | null;
  code?: string | null;
  /** @format int32 */
  oldId?: number | null;
  currencyRates?: CurrencyRateEntity[] | null;
  deals?: DealEntity[] | null;
  offers?: OfferEntity[] | null;
}

export interface CurrencyRateDto {
  /** @format int32 */
  id?: number;
  date?: DateOnly;
  /** @format int32 */
  currencyId?: number;
  /** @format double */
  rate?: number;
}

export interface CurrencyRateDtoLazyResponse {
  rows?: CurrencyRateDto[] | null;
  /** @format int32 */
  totalRecords?: number;
}

export interface CurrencyRateEntity {
  /** @format int32 */
  id?: number;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format date-time */
  deletedAt?: string | null;
  /** @format int32 */
  exchangeSessionId?: number | null;
  date?: DateOnly;
  /** @format int32 */
  currencyId?: number;
  /** @format double */
  rate?: number;
  /** @format int32 */
  oldId?: number | null;
  currency?: CurrencyEntity;
  exchangeSession?: ExchangeSessionEntity;
}

export interface CurrencyRateReportDto {
  date?: string | null;
  /** @format double */
  usdToBgn?: number;
  /** @format double */
  eurToBgn?: number;
}

export interface CurrencyRateReportDtoLazyResponse {
  rows?: CurrencyRateReportDto[] | null;
  /** @format int32 */
  totalRecords?: number;
}

export interface DailyDealsReportDto {
  /** @format int32 */
  offerId?: number | null;
  dateSession?: string | null;
  contractNumber?: string | null;
  /** @format int32 */
  offerNumberInWeek?: number;
  offerDateRegister?: string | null;
  offerName?: string | null;
  notes?: string | null;
  quantity?: string | null;
  measurement?: string | null;
  price?: string | null;
  priceTotal?: string | null;
  vat?: string | null;
}

export interface DailyDealsReportDtoLazyResponse {
  rows?: DailyDealsReportDto[] | null;
  /** @format int32 */
  totalRecords?: number;
}

export type DateOnly = Date;

/** @format int32 */
export enum DayOfWeek {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
  Value5 = 5,
  Value6 = 6,
}

export interface DealDto {
  /** @format int32 */
  id?: number;
  dealDate?: DateOnly;
  /** @format int32 */
  saleBrokerId?: number | null;
  /** @format int32 */
  buyBrokerId?: number | null;
  /** @format double */
  quantity?: number | null;
  /** @format double */
  price?: number | null;
  /** @format int32 */
  currencyId?: number | null;
  /** @format int32 */
  offerId?: number | null;
  /** @format int32 */
  saleBrokerHouseId?: number | null;
  /** @format int32 */
  buyBrokerHouseId?: number | null;
  /** @format int32 */
  orderInOffer?: number;
  commodities?: UpdateCommodityForContractDto[] | null;
}

export interface DealEntity {
  /** @format int32 */
  id?: number;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format date-time */
  deletedAt?: string | null;
  /** @format int32 */
  exchangeSessionId?: number | null;
  /** @format double */
  quantity?: number | null;
  /** @format int32 */
  contractsCount?: number | null;
  /** @format double */
  price?: number | null;
  dealDate?: DateOnly;
  /** @format int32 */
  currencyId?: number | null;
  /** @format double */
  currencyRate?: number | null;
  /** @format int32 */
  documentNumber?: number | null;
  notes?: string | null;
  /** @format int32 */
  canceled?: number | null;
  /** @format int32 */
  saleBrokerId?: number | null;
  /** @format int32 */
  buyBrokerId?: number | null;
  /** @format int32 */
  saleBrokerHouseId?: number | null;
  /** @format int32 */
  buyBrokerHouseId?: number | null;
  /** @format int32 */
  offerId?: number;
  /** @format int32 */
  isFinished?: number;
  /** @format int32 */
  orderInOffer?: number;
  /** @format int32 */
  oldId?: number | null;
  /** @format double */
  offerCurrentQuantity?: number;
  bidDeals?: BidEntity[] | null;
  bidForDeals?: BidEntity[] | null;
  buyBroker?: BrokerEntity;
  buyBrokerHouse?: BrokerHouseEntity;
  currency?: CurrencyEntity;
  dealOfferCommodities?: DealOfferCommodityEntity[] | null;
  offer?: OfferEntity;
  dealTickets?: DealTicketEntity[] | null;
  contractDeals?: ContractDealEntity[] | null;
  exchangeSession?: ExchangeSessionEntity;
  saleBroker?: BrokerEntity;
  saleBrokerHouse?: BrokerHouseEntity;
}

export interface DealOfferCommodityEntity {
  /** @format int32 */
  id?: number;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format date-time */
  deletedAt?: string | null;
  /** @format int32 */
  dealId?: number;
  /** @format int32 */
  offerCommodityId?: number;
  /** @format double */
  quantity?: number;
  /** @format double */
  price?: number;
  notes?: string | null;
  /** @format int32 */
  measurementId?: number | null;
  /** @format int32 */
  oldId?: number | null;
  deal?: DealEntity;
  measurement?: MeasurementEntity;
  offerCommodity?: OfferCommodityEntity;
}

export interface DealReportDto {
  /** @format int32 */
  id?: number;
  /** @format int32 */
  offerId?: number;
  offerNumber?: string | null;
  exchangeCircle?: string | null;
  offerType?: string | null;
  offerName?: string | null;
  /** @format double */
  quantity?: number | null;
  measuringUnitCurrency?: string | null;
  /** @format double */
  singlePrice?: number | null;
  /** @format double */
  totalAmount?: number | null;
  ticket?: string | null;
  submittedByBroker?: string | null;
  counterParty?: string | null;
  dealDate?: string | null;
  /** @format int32 */
  contractsCount?: number;
  submitterBrokerCode?: string | null;
  otherBrokerCode?: string | null;
}

export interface DealReportDtoLazyResponse {
  rows?: DealReportDto[] | null;
  /** @format int32 */
  totalRecords?: number;
}

export interface DealTicketEntity {
  /** @format int32 */
  ticketId?: number;
  /** @format int32 */
  dealId?: number;
  /** @format int32 */
  oldId?: number | null;
  deal?: DealEntity;
  ticket?: TicketEntity;
}

export interface DeliveryTimeDto {
  /** @format int32 */
  id?: number;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string | null;
  value?: string | null;
}

export interface DeliveryTimeDtoLazyResponse {
  rows?: DeliveryTimeDto[] | null;
  /** @format int32 */
  totalRecords?: number;
}

export interface DeliveryTimeEntity {
  /** @format int32 */
  id?: number;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format date-time */
  deletedAt?: string | null;
  value?: string | null;
  /** @format int32 */
  oldId?: number | null;
  offers?: OfferEntity[] | null;
}

export interface DropdownItem {
  /** @format int32 */
  id?: number;
  /** @format int32 */
  key?: number;
  description?: string | null;
}

export interface ExchangeCircleEntity {
  /** @format int32 */
  id?: number;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format date-time */
  deletedAt?: string | null;
  name?: string | null;
  label?: string | null;
  /** @format int32 */
  order?: number;
  /** @format int32 */
  oldId?: number | null;
  commodities?: CommodityEntity[] | null;
  commodityGroups?: CommodityGroupEntity[] | null;
  offers?: OfferEntity[] | null;
}

export interface ExchangeSessionBrokerDto {
  /** @format int32 */
  brokerId?: number;
  code?: string | null;
  name?: string | null;
  brokerHouseCode?: string | null;
  brokerHouseName?: string | null;
}

export interface ExchangeSessionBrokerEntity {
  /** @format int32 */
  id?: number;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format date-time */
  deletedAt?: string | null;
  /** @format int32 */
  brokerId?: number;
  /** @format int32 */
  exchangeSessionId?: number;
  notes?: string | null;
  /** @format int32 */
  oldId?: number | null;
  broker?: BrokerEntity;
  exchangeSession?: ExchangeSessionEntity;
}

export interface ExchangeSessionDto {
  /** @format int32 */
  id?: number;
  date?: string | null;
  day?: string | null;
  /** @format int32 */
  presentBrokers?: number;
  /** @format int32 */
  dealForSession?: number;
  /** @format int32 */
  exchangeWeekId?: number;
  /** @format int32 */
  numberInYear?: number;
  isLive?: boolean;
  isOnline?: boolean;
  brokers?: ExchangeSessionBrokerDto[] | null;
}

export interface ExchangeSessionEntity {
  /** @format int32 */
  id?: number;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format date-time */
  deletedAt?: string | null;
  date?: DateOnly;
  /** @format int32 */
  exchangeWeekId?: number;
  /** @format int32 */
  sessionNumberInWeek?: number;
  isHidden?: boolean;
  isOnline?: boolean;
  /** @format int32 */
  oldId?: number | null;
  bids?: BidEntity[] | null;
  currencyRates?: CurrencyRateEntity[] | null;
  deals?: DealEntity[] | null;
  exchangeWeek?: ExchangeWeekEntity;
  exchangeSessionBrokers?: ExchangeSessionBrokerEntity[] | null;
}

export interface ExchangeWeekEntity {
  /** @format int32 */
  id?: number;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format date-time */
  deletedAt?: string | null;
  /** @format int32 */
  numberInYear?: number;
  notes?: string | null;
  /** @format int32 */
  oldId?: number | null;
  /** @format int32 */
  year?: number;
  exchangeSessions?: ExchangeSessionEntity[] | null;
}

export interface ForgottenPasswordRequestDto {
  usernameOrEmail?: string | null;
}

export interface GuaranteeDepositDto {
  /** @format int32 */
  id?: number;
  company?: string | null;
  contractNumber?: string | null;
  /** @format double */
  amount?: number | null;
  receivedDate?: DateOnly;
  returnedDate?: DateOnly;
  /** @format double */
  returnedAmount?: number | null;
  /** @format double */
  remainder?: number | null;
  note?: string | null;
  /** @format int32 */
  orderNumber?: number;
}

export interface GuaranteeDepositDtoStringDecimalDictionaryLazyResponse {
  rows?: GuaranteeDepositDto[] | null;
  /** @format int32 */
  totalRecords?: number;
  subtotals?: Record<string, number>;
}

export interface InstituteEntity {
  /** @format int32 */
  id?: number;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format date-time */
  deletedAt?: string | null;
  /** @format int32 */
  typeId?: number | null;
  name?: string | null;
  /** @format int32 */
  oldId?: number | null;
  companies?: CompanyEntity[] | null;
  type?: InstituteTypeEntity;
}

export interface InstituteTypeEntity {
  /** @format int32 */
  id?: number;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format date-time */
  deletedAt?: string | null;
  name?: string | null;
  /** @format int32 */
  oldId?: number | null;
  institutes?: InstituteEntity[] | null;
}

export interface LiveSessionInfoDto {
  /** @format int32 */
  exchangeSessionId?: number;
  /** @format int32 */
  offerId?: number;
  /** @format int32 */
  currentSessionOperatorId?: number;
  isOnline?: boolean;
}

export interface LoginRequestDto {
  username?: string | null;
  password?: string | null;
}

export interface LoginResponseDto {
  /** @format int32 */
  userId?: number;
  username?: string | null;
  role?: string | null;
  shouldChangePassword?: boolean;
  /** @format int32 */
  brokerId?: number | null;
  names?: string | null;
}

export interface MeasurementDto {
  /** @format int32 */
  id?: number;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string | null;
  name?: string | null;
  plural?: string | null;
  type?: string | null;
}

export interface MeasurementDtoLazyResponse {
  rows?: MeasurementDto[] | null;
  /** @format int32 */
  totalRecords?: number;
}

export interface MeasurementEntity {
  /** @format int32 */
  id?: number;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format date-time */
  deletedAt?: string | null;
  name?: string | null;
  plural?: string | null;
  type?: string | null;
  /** @format int32 */
  oldId?: number | null;
  commodities?: CommodityEntity[] | null;
  offerCommodities?: OfferCommodityEntity[] | null;
  offers?: OfferEntity[] | null;
}

export interface MegaReportDto {
  offerNumber?: string | null;
  offerName?: string | null;
  /** @format double */
  dealPrice?: number | null;
  /** @format double */
  dealQuantity?: number | null;
  exchangeCircle?: string | null;
  offerType?: string | null;
  nsiCode?: string | null;
  tickets?: string | null;
  contractDate?: string | null;
  contractNumber?: string | null;
  /** @format int32 */
  contractId?: number | null;
  expireAt?: string | null;
  submittedByBroker?: string | null;
  submittedByBrokerHouse?: string | null;
  counterPartyBroker?: string | null;
  counterPartyBrokerHouse?: string | null;
  companyBuyer?: string | null;
  companySeller?: string | null;
  /** @format double */
  commission?: number | null;
}

export interface MegaReportDtoLazyResponse {
  rows?: MegaReportDto[] | null;
  /** @format int32 */
  totalRecords?: number;
}

export interface MessageResponse {
  message?: string | null;
}

export interface MonthlyReportDto {
  offerNumber?: string | null;
  originalOfferNumber?: string | null;
  offerType?: string | null;
  dealDate?: string | null;
  contractNumber?: string | null;
  exchangeCircle?: string | null;
  nsiCode?: string | null;
  offerName?: string | null;
  /** @format double */
  sellQuantity?: number;
  /** @format double */
  buyQuantity?: number;
  measurement?: string | null;
  /** @format double */
  buyMinPrice?: number;
  /** @format double */
  sellMaxPrice?: number;
  /** @format double */
  dealQuantity?: number | null;
  /** @format double */
  dealPrice?: number | null;
  /** @format double */
  totalPrice?: number | null;
  /** @format double */
  totalPriceForContracts?: number | null;
  submittedByBroker?: string | null;
  brokerCounterParty?: string | null;
  submittedByBrokerHouse?: string | null;
  counterPartyBrokerHouse?: string | null;
}

export interface OfferCommodityDto {
  /** @format int32 */
  commodityId?: number | null;
  /** @format int32 */
  measurementId?: number | null;
  /** @format double */
  quantity?: number | null;
  notes?: string | null;
  /** @format int32 */
  id?: number | null;
}

export interface OfferCommodityEntity {
  /** @format int32 */
  id?: number;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format date-time */
  deletedAt?: string | null;
  /** @format int32 */
  offerId?: number;
  /** @format int32 */
  commodityId?: number;
  /** @format int32 */
  measurementId?: number;
  /** @format double */
  quantity?: number;
  /** @format int32 */
  oldId?: number | null;
  notes?: string | null;
  commodity?: CommodityEntity;
  dealOfferCommodities?: DealOfferCommodityEntity[] | null;
  measurement?: MeasurementEntity;
  offer?: OfferEntity;
}

export interface OfferDto {
  /** @format int32 */
  id?: number | null;
  /** @format int32 */
  exchangeCircleId?: number | null;
  /** @format int32 */
  offerTypeId?: number;
  offerTypeShortName?: string | null;
  name?: string | null;
  nsiCode?: string | null;
  /** @format int32 */
  order?: number | null;
  number?: string | null;
  /** @format date-time */
  registeredAt?: string | null;
  /** @format date-time */
  copiedAt?: string | null;
  /** @format date-time */
  closedAt?: string | null;
  expireOn?: DateOnly;
  /** @format int32 */
  isBuy?: number;
  /** @format int32 */
  submittedByBrokerId?: number | null;
  /** @format int32 */
  saleBrokerId?: number | null;
  /** @format int32 */
  buyBrokerId?: number | null;
  notes?: string | null;
  /** @format int32 */
  currencyId?: number | null;
  /** @format double */
  startPrice?: number | null;
  /** @format double */
  startPriceBuy?: number | null;
  vatIncluded?: boolean;
  /** @format double */
  startPriceSell?: number | null;
  /** @format double */
  netQuantity?: number | null;
  /** @format int32 */
  measurementId?: number | null;
  /** @format int32 */
  startContractsCount?: number | null;
  place?: string | null;
  deliveryTime?: string | null;
  /** @format int32 */
  deliveryTimeId?: number | null;
  /** @format double */
  minPriceBuy?: number | null;
  /** @format double */
  maxPriceBuy?: number | null;
  /** @format double */
  minPriceSell?: number | null;
  /** @format double */
  maxPriceSell?: number | null;
  /** @format int32 */
  approved?: number;
  /** @format int32 */
  cpvCodeId?: number | null;
  /** @format date-time */
  dateRegister?: string | null;
  /** @format int32 */
  oldId?: number | null;
  isUrgent?: boolean;
  inCurrentWeek?: boolean;
  archived?: boolean;
  currencyName?: string | null;
  /** @format double */
  step?: number | null;
  offerCommodities?: OfferCommodityDto[] | null;
}

export interface OfferEntity {
  /** @format int32 */
  id?: number;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format date-time */
  deletedAt?: string | null;
  /** @format int32 */
  exchangeCircleId?: number | null;
  /** @format int32 */
  baseOfferId?: number | null;
  /** @format int32 */
  offerTypeId?: number;
  name?: string | null;
  nsiCode?: string | null;
  /** @format int32 */
  order?: number | null;
  number?: string | null;
  /** @format date-time */
  registeredAt?: string | null;
  /** @format date-time */
  copiedAt?: string | null;
  /** @format date-time */
  closedAt?: string | null;
  expireOn?: DateOnly;
  /** @format int32 */
  isBuy?: number;
  /** @format int32 */
  submittedByBrokerId?: number | null;
  /** @format int32 */
  saleBrokerId?: number | null;
  /** @format int32 */
  buyBrokerId?: number | null;
  notes?: string | null;
  /** @format int32 */
  currencyId?: number | null;
  /** @format double */
  startPrice?: number | null;
  vatIncluded?: boolean;
  /** @format double */
  startPriceBuy?: number | null;
  /** @format double */
  startPriceSell?: number | null;
  /** @format double */
  netQuantity?: number | null;
  /** @format double */
  startingQuantity?: number | null;
  /** @format int32 */
  measurementId?: number | null;
  /** @format int32 */
  startContractsCount?: number | null;
  place?: string | null;
  deliveryTime?: string | null;
  /** @format int32 */
  deliveryTimeId?: number | null;
  /** @format double */
  minPriceBuy?: number | null;
  /** @format double */
  maxPriceBuy?: number | null;
  /** @format double */
  minPriceSell?: number | null;
  /** @format double */
  maxPriceSell?: number | null;
  /** @format int32 */
  approved?: number;
  /** @format int32 */
  cpvCodeId?: number | null;
  /** @format date-time */
  dateRegister?: string | null;
  /** @format double */
  step?: number | null;
  /** @format int32 */
  oldId?: number | null;
  baseOffer?: OfferEntity;
  bids?: BidEntity[] | null;
  buyBroker?: BrokerEntity;
  cpvCode?: CpvCodeEntity;
  currency?: CurrencyEntity;
  deliveryTimeNavigation?: DeliveryTimeEntity;
  exchangeCircle?: ExchangeCircleEntity;
  inverseBaseOffer?: OfferEntity[] | null;
  measurement?: MeasurementEntity;
  offerType?: OfferTypeEntity;
  offerCommodities?: OfferCommodityEntity[] | null;
  deals?: DealEntity[] | null;
  saleBroker?: BrokerEntity;
  submittedByBroker?: BrokerEntity;
}

export interface OfferOnlineTableDto {
  /** @format int32 */
  id?: number;
  /** @format int32 */
  exchangeCircleId?: number | null;
  name?: string | null;
  number?: string | null;
  /** @format double */
  startPrice?: number | null;
  /** @format double */
  netQuantity?: number | null;
  /** @format int32 */
  measurementId?: number | null;
  measurementName?: string | null;
  /** @format int32 */
  startContractsCount?: number | null;
  submittedByBroker?: string | null;
  /** @format int32 */
  numberInCurrentWeek?: number;
}

export interface OfferOnlineTableResultDto {
  data?: Record<string, OfferOnlineTableDto[]>;
}

export interface OfferReportDto {
  /** @format int32 */
  id?: number;
  number?: string | null;
  exchangeCircle?: string | null;
  offerType?: string | null;
  offerName?: string | null;
  nsiCode?: string | null;
  /** @format double */
  netQuantity?: number | null;
  measurement?: string | null;
  /** @format double */
  startPrice?: number | null;
  currencyWithMeasurement?: string | null;
  submittedByBroker?: string | null;
  registeredAt?: string | null;
  expireOn?: string | null;
}

export interface OfferReportDtoLazyResponse {
  rows?: OfferReportDto[] | null;
  /** @format int32 */
  totalRecords?: number;
}

export interface OfferSummaryDto {
  /** @format int32 */
  id?: number;
  exchangeCircle?: string | null;
  name?: string | null;
  number?: string | null;
  /** @format int32 */
  numberInWeek?: number;
}

export interface OfferTableDto {
  /** @format int32 */
  id?: number;
  /** @format int32 */
  exchangeCircleId?: number | null;
  /** @format int32 */
  offerTypeId?: number;
  offerTypeShortName?: string | null;
  name?: string | null;
  number?: string | null;
  /** @format date-time */
  closedAt?: string | null;
  expireOn?: DateOnly;
  /** @format int32 */
  currencyId?: number | null;
  currencyName?: string | null;
  /** @format double */
  startPrice?: number | null;
  /** @format double */
  netQuantity?: number | null;
  /** @format int32 */
  measurementId?: number | null;
  measurementName?: string | null;
  /** @format int32 */
  startContractsCount?: number | null;
  place?: string | null;
  deliveryTime?: string | null;
  /** @format int32 */
  deliveryTimeId?: number | null;
  /** @format int32 */
  approved?: number;
  houseBrokerAndBroker?: string | null;
  /** @format double */
  offerUsage?: number;
  numberInWeek?: string | null;
  isUrgent?: boolean;
  allowOnlineTrading?: boolean;
}

export interface OfferTablesResultDto {
  data?: Record<string, OfferTableDto[]>;
}

export interface OfferTypeEntity {
  /** @format int32 */
  id?: number;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format date-time */
  deletedAt?: string | null;
  shortName?: string | null;
  exportName?: string | null;
  name?: string | null;
  /** @format int32 */
  isBuy?: number;
  /** @format int32 */
  oldId?: number | null;
  offers?: OfferEntity[] | null;
}

export interface OffersCountDto {
  /** @format int32 */
  all?: number | null;
  /** @format int32 */
  withDeal?: number;
  /** @format int32 */
  withTicket?: number;
  /** @format int32 */
  withContract?: number;
  /** @format int32 */
  forApproval?: number;
}

export interface OldContractReportDto {
  commodity?: string | null;
  companySeller?: string | null;
  companyBuyer?: string | null;
  brokerSeller?: string | null;
  brokerBuyer?: string | null;
  brokerHouseSeller?: string | null;
  brokerHouseBuyer?: string | null;
  /** @format double */
  quantity?: number;
  /** @format double */
  price?: number;
  /** @format double */
  singlePrice?: number;
  /** @format double */
  commission?: number;
  /** @format double */
  ddsPercentage?: number;
  /** @format int32 */
  workingYear?: number;
  /** @format int32 */
  number?: number;
  date?: string | null;
}

export interface OldContractReportDtoLazyResponse {
  rows?: OldContractReportDto[] | null;
  /** @format int32 */
  totalRecords?: number;
}

export interface OnlineSessionEventEntity {
  /** @format int32 */
  id?: number;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format date-time */
  deletedAt?: string | null;
  /** @format int32 */
  userId?: number;
  /** @format int32 */
  brokerId?: number | null;
  /** @format int32 */
  exchangeSessionId?: number;
  identifier?: string | null;
  eventMessage?: string | null;
  user?: UserEntity;
  broker?: BrokerEntity;
  eventType?: string | null;
  exchangeSession?: ExchangeSessionEntity;
}

export enum OnlineSessionState {
  Preparation = "Preparation",
  WaitForSubmitter = "WaitForSubmitter",
  Trading = "Trading",
  WaitForSessionOperator = "WaitForSessionOperator",
}

export interface OnlineSessionStateDto {
  /** @format int32 */
  onlineSessionOperatorId?: number;
  /** @format int32 */
  exchangeSessionId?: number;
  /** @format int32 */
  currentOfferId?: number;
  fixedQuantity?: boolean;
  data?: SessionDetailsDto;
  brokersOnline?: BrokerSessionDto[] | null;
}

export interface OnlineSessionSubmitterDecisionDto {
  /** @format double */
  startPrice?: number;
  /** @format double */
  netQuantity?: number;
  fixedQuantity?: boolean;
  confirmed?: boolean;
}

export interface OnlineSessionSyncDto {
  /** @format int32 */
  remainingSeconds?: number;
  onlineSessionState?: OnlineSessionState;
}

export interface ProtocolsReportDto {
  numberInWeek?: string | null;
  offerNumber?: string | null;
  offerType?: string | null;
  offerName?: string | null;
  notes?: string | null;
  registeredAt?: string | null;
  buyMinMax?: string | null;
  sellMinMax?: string | null;
  currencyWithMeasurement?: string | null;
  exchangeCircle?: string | null;
}

export interface RegionalCenterEntity {
  /** @format int32 */
  id?: number;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format date-time */
  deletedAt?: string | null;
  name?: string | null;
  phone?: string | null;
  fax?: string | null;
  email?: string | null;
  notes?: string | null;
  /** @format int32 */
  oldId?: number | null;
  brokerHouses?: BrokerHouseEntity[] | null;
}

export interface RegistryOfficeBrokerHouseReportDto {
  contractNumber?: string | null;
  contractDate?: string | null;
  brokerHouseSeller?: string | null;
  brokerHouseBuyer?: string | null;
  offerName?: string | null;
  offerType?: string | null;
  /** @format double */
  quantity?: number;
  measurement?: string | null;
  /** @format double */
  singlePrice?: number | null;
  currencyMeasurement?: string | null;
  /** @format double */
  totalPriceContract?: number;
}

export interface RegistryOfficeBrokerHouseReportDtoLazyResponse {
  rows?: RegistryOfficeBrokerHouseReportDto[] | null;
  /** @format int32 */
  totalRecords?: number;
}

export interface RegistryOfficeBrokerReportDto {
  contractNumber?: string | null;
  contractDate?: string | null;
  brokerSeller?: string | null;
  brokerBuyer?: string | null;
  offerName?: string | null;
  offerType?: string | null;
  /** @format double */
  quantity?: number;
  measurement?: string | null;
  /** @format double */
  singlePrice?: number | null;
  currencyMeasurement?: string | null;
  /** @format double */
  totalPriceContract?: number;
}

export interface RegistryOfficeBrokerReportDtoLazyResponse {
  rows?: RegistryOfficeBrokerReportDto[] | null;
  /** @format int32 */
  totalRecords?: number;
}

export interface RoleEntity {
  /** @format int32 */
  id?: number;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format date-time */
  deletedAt?: string | null;
  name?: string | null;
  /** @format int32 */
  oldId?: number | null;
}

export interface SendBrokerOfferToMailParameters {
  file?: File[] | null;
  htmlBody?: string | null;
}

export interface SessionDealDto {
  offerName?: string | null;
  /** @format double */
  quantity?: number;
  /** @format double */
  price?: number;
  /** @format int32 */
  buyBrokerId?: number;
  /** @format int32 */
  saleBrokerId?: number;
  submitterBrokerCode?: string | null;
  otherBrokerCode?: string | null;
}

export interface SessionDetailsDto {
  /** @format int32 */
  exchangeSessionId?: number;
  buyBids?: BidDto[] | null;
  sellBids?: BidDto[] | null;
  offerSummary?: SessionOfferSummary;
  measurement?: string | null;
}

export interface SessionExchangeCircleItem {
  /** @format int32 */
  id?: number;
  /** @format int32 */
  key?: number;
  description?: string | null;
  offers?: SessionOfferItem[] | null;
}

export interface SessionOfferItem {
  /** @format int32 */
  id?: number;
  /** @format int32 */
  key?: number;
  description?: string | null;
  offerType?: string | null;
  isFirst?: boolean;
  isLast?: boolean;
}

export interface SessionOfferOptionsDto {
  exchangeCircleItems?: SessionExchangeCircleItem[] | null;
  isLive?: boolean;
}

export interface SessionOfferSummary {
  /** @format int32 */
  numberInWeek?: number;
  exchangeCircle?: string | null;
  offerType?: string | null;
  offerName?: string | null;
  deliveryTime?: string | null;
  /** @format double */
  startPrice?: number;
  /** @format double */
  netQuantity?: number;
  /** @format int32 */
  contractsCount?: number;
  currency?: string | null;
  measurement?: string | null;
  measurementType?: string | null;
  currencyWithMeasurement?: string | null;
  place?: string | null;
  registeredAt?: string | null;
  notes?: string | null;
  submittedByBroker?: string | null;
  isBuy?: boolean;
  /** @format int32 */
  submittedByBrokerId?: number | null;
  number?: string | null;
  /** @format double */
  step?: number | null;
  vatIncluded?: boolean;
}

export interface SessionScreenDto {
  offerNumberInWeek?: string | null;
  exchangeCircle?: string | null;
  offerType?: string | null;
  /** @format int32 */
  startContractsCount?: number;
  deliveryTime?: string | null;
  offerName?: string | null;
  /** @format double */
  netQuantity?: number;
  /** @format double */
  startPrice?: number;
  currency?: string | null;
  measurement?: string | null;
  measurementType?: string | null;
  buyBids?: number[] | null;
  sellBids?: number[] | null;
}

export interface SignalRError {
  message?: string | null;
  values?: any;
}

export interface TicketDto {
  /** @format int32 */
  id?: number | null;
  /** @format int32 */
  number?: number;
  /** @format int32 */
  index?: number | null;
  date?: DateOnly;
  /** @format int32 */
  dealId?: number | null;
  notes?: string | null;
  indexes?: TicketDto[] | null;
}

export interface TicketEntity {
  /** @format int32 */
  id?: number;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format date-time */
  deletedAt?: string | null;
  /** @format int32 */
  number?: number;
  /** @format int32 */
  index?: number | null;
  date?: DateOnly;
  notes?: string | null;
  /** @format int32 */
  oldId?: number | null;
  dealTickets?: DealTicketEntity[] | null;
  contractTickets?: ContractTicketEntity[] | null;
}

export interface UpdateAccountingDto {
  /** @format int32 */
  id?: number;
  /** @format double */
  commission?: number;
  invoiceNumber?: string | null;
  /** @format int32 */
  isPaid?: number;
  isBuy?: boolean;
  issueDate?: DateOnly;
  paidDate?: DateOnly;
  note?: string | null;
}

export interface UpdateBidDto {
  isBuy?: boolean | null;
  /** @format double */
  price?: number | null;
  /** @format double */
  netQuantity?: number | null;
  /** @format int32 */
  brokerId?: number | null;
}

export interface UpdateBrokerDto {
  /** @format int32 */
  brokerHouseId?: number | null;
  name?: string | null;
  middleName?: string | null;
  code?: string | null;
  phone?: string | null;
  fax?: string | null;
  email?: string | null;
  egn?: string | null;
  cardNumber?: string | null;
  homeAddress?: string | null;
  homePhone?: string | null;
  officeAddress?: string | null;
  officePhone?: string | null;
  docPermissionDksbt?: string | null;
  docBrokerCertificate?: string | null;
  ssbRegistryPage?: string | null;
  docPreReregistrationDksbt?: string | null;
  notes?: string | null;
  /** @format int32 */
  active?: number;
  /** @format int32 */
  id?: number;
}

export interface UpdateBrokerHouseDto {
  name?: string | null;
  code?: string | null;
  /** @format int32 */
  brokerHouseMembershipId?: number | null;
  phone?: string | null;
  fax?: string | null;
  email?: string | null;
  eik?: string | null;
  taxNumber?: string | null;
  documentNumber?: string | null;
  registryNumber?: string | null;
  subscribedAt?: DateOnly;
  unsubscribedAt?: DateOnly;
  postCode?: string | null;
  city?: string | null;
  address?: string | null;
  correspondenceAddress?: string | null;
  person?: string | null;
  personPosition?: string | null;
  subscriptionNote?: string | null;
  unsubscriptionNote?: string | null;
  notes?: string | null;
  /** @format int32 */
  activity?: number | null;
  /** @format int32 */
  id?: number;
}

export interface UpdateBrokerHousePaymentDto {
  /** @format int32 */
  brokerHouseId?: number;
  /** @format int32 */
  paidFirst?: number | null;
  /** @format int32 */
  paidSecond?: number | null;
  /** @format int32 */
  paidPartially?: number | null;
  firstNotes?: string | null;
  partiallyNotes?: string | null;
  year?: string | null;
  secondNotes?: string | null;
  /** @format int32 */
  id?: number;
}

export interface UpdateCommissionDto {
  /** @format double */
  from?: number | null;
  /** @format double */
  to?: number | null;
  /** @format double */
  tax?: number;
  /** @format int32 */
  type?: number;
  /** @format int32 */
  id?: number;
}

export interface UpdateCommodityDto {
  name?: string | null;
  nsiCode?: string | null;
  /** @format int32 */
  measurementId?: number;
  /** @format int32 */
  exchangeCircleId?: number;
  /** @format int32 */
  id?: number;
}

export interface UpdateCommodityForContractDto {
  /** @format int32 */
  offerCommodityId?: number;
  /** @format double */
  quantity?: number;
  /** @format double */
  price?: number;
  notes?: string | null;
  /** @format int32 */
  measurementId?: number | null;
  /** @format int32 */
  id?: number;
}

export interface UpdateCommodityForDealDto {
  /** @format int32 */
  offerCommodityId?: number;
  /** @format double */
  quantity?: number;
  /** @format double */
  price?: number;
  /** @format int32 */
  id?: number;
  /** @format int32 */
  measurementId?: number | null;
}

export interface UpdateCompanyDto {
  /** @format int32 */
  instituteId?: number | null;
  name?: string | null;
  phone?: string | null;
  fax?: string | null;
  eik?: string | null;
  taxNumber?: string | null;
  city?: string | null;
  address?: string | null;
  correspondenceAddress?: string | null;
  person?: string | null;
  notes?: string | null;
  /** @format int32 */
  id?: number;
}

export interface UpdateCpvCodeDto {
  name?: string | null;
  code?: string | null;
  /** @format int32 */
  id?: number;
}

export interface UpdateCurrencyRateDto {
  /** @format int32 */
  id?: number;
  /** @format double */
  rate?: number;
}

export interface UpdateDeliveryTimeDto {
  value?: string | null;
  /** @format int32 */
  id?: number;
}

export interface UpdateGuaranteeDepositDto {
  company?: string | null;
  contractNumber?: string | null;
  /** @format double */
  amount?: number | null;
  receivedDate?: DateOnly;
  returnedDate?: DateOnly;
  /** @format double */
  returnedAmount?: number | null;
  /** @format double */
  remainder?: number | null;
  note?: string | null;
  /** @format int32 */
  id?: number;
}

export interface UpdateMeasurementDto {
  name?: string | null;
  plural?: string | null;
  type?: string | null;
  /** @format int32 */
  id?: number;
}

export interface UpdateOfferDto {
  isUrgent?: boolean | null;
  /** @format int32 */
  exchangeCircleId?: number | null;
  /** @format int32 */
  offerTypeId?: number | null;
  name?: string | null;
  /** @format int32 */
  nsiCodeId?: number | null;
  /** @format double */
  netQuantity?: number | null;
  /** @format int32 */
  measurementId?: number | null;
  /** @format int32 */
  startContractsCount?: number | null;
  place?: string | null;
  /** @format int32 */
  deliveryTimeId?: number | null;
  /** @format double */
  startPrice?: number | null;
  vatIncluded?: boolean;
  /** @format int32 */
  currencyId?: number | null;
  expireOn?: DateOnly;
  /** @format int32 */
  submittedByBrokerId?: number | null;
  registeredAt?: DateOnly;
  /** @format date-time */
  dateRegister?: Date | null;
  /** @format int32 */
  cpvCodeId?: number | null;
  notes?: string | null;
  /** @format double */
  step?: number | null;
  offerCommodities?: OfferCommodityDto[] | null;
  archived?: boolean | null;
}

export interface UpdateUserDto {
  password?: string | null;
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  active?: boolean | null;
  /** @format int32 */
  roleId?: number | null;
  /** @format int32 */
  brokerId?: number | null;
}

export interface UserDto {
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format date-time */
  deletedAt?: string | null;
  /** @format int32 */
  id: number;
  /** @minLength 1 */
  username: string;
  /** @minLength 1 */
  email: string;
  firstName?: string | null;
  lastName?: string | null;
  active: boolean;
  /** @format int32 */
  brokerId?: number | null;
  /** @format int32 */
  roleId: number;
}

export interface UserDtoLazyResponse {
  rows?: UserDto[] | null;
  /** @format int32 */
  totalRecords?: number;
}

export interface UserEntity {
  /** @format int32 */
  id?: number;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format date-time */
  deletedAt?: string | null;
  /** @minLength 1 */
  username: string;
  /** @minLength 1 */
  email: string;
  /** @minLength 1 */
  hashedPassword: string;
  /** @minLength 1 */
  salt: string;
  active: boolean;
  firstName?: string | null;
  lastName?: string | null;
  phone?: string | null;
  /** @format date-time */
  lastLogged?: string | null;
  /** @format int32 */
  roleId?: number;
  /** @format int32 */
  brokerId?: number | null;
  /** @format int32 */
  oldId?: number | null;
  shouldChangePassword?: boolean;
  role?: RoleEntity;
  broker?: BrokerEntity;
}

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";
import axios from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios;
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title SCE
 * @version 1.0
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Accounting
     * @name GetAccountingTreeTable
     * @request GET:/api/accounting/{year}
     */
    getAccountingTreeTable: (year: number, params: RequestParams = {}) =>
      this.request<AccountingTableContractsDto[], MessageResponse>({
        path: `/api/accounting/${year}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Accounting
     * @name UpdateContract
     * @request PUT:/api/accounting/{contractId}
     */
    updateContract: (contractId: number, data: UpdateAccountingDto, params: RequestParams = {}) =>
      this.request<boolean, MessageResponse>({
        path: `/api/accounting/${contractId}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Accounting
     * @name GenerateAccountingExcel
     * @request POST:/api/accounting/generateExcel/{year}
     */
    generateAccountingExcel: (year: number, params: RequestParams = {}) =>
      this.request<BlobPart, any>({format: "arraybuffer",
        path: `/api/accounting/generateExcel/${year}`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name Login
     * @request POST:/api/auth/login
     */
    login: (data: LoginRequestDto, params: RequestParams = {}) =>
      this.request<LoginResponseDto, any>({
        path: `/api/auth/login`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name CheckIfAuthenticated
     * @request GET:/api/auth/checkIfAuthenticated
     */
    checkIfAuthenticated: (params: RequestParams = {}) =>
      this.request<LoginResponseDto, any>({
        path: `/api/auth/checkIfAuthenticated`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name Logout
     * @request GET:/api/auth/logout
     */
    logout: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/auth/logout`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name ChangePassword
     * @request PUT:/api/auth/changePassword
     */
    changePassword: (data: ChangePasswordRequestDto, params: RequestParams = {}) =>
      this.request<boolean, MessageResponse>({
        path: `/api/auth/changePassword`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name ResetPassword
     * @request PUT:/api/auth/resetPassword
     */
    resetPassword: (data: ForgottenPasswordRequestDto, params: RequestParams = {}) =>
      this.request<boolean, MessageResponse>({
        path: `/api/auth/resetPassword`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bids
     * @name CreateBid
     * @request POST:/api/bids/{exchangeSessionId}/{offerId}
     */
    createBid: (exchangeSessionId: number, offerId: number, data: CreateBidDto, params: RequestParams = {}) =>
      this.request<BidDto, MessageResponse>({
        path: `/api/bids/${exchangeSessionId}/${offerId}`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bids
     * @name CreateBrokerBid
     * @request POST:/api/bids
     */
    createBrokerBid: (data: CreateBrokerBidDto, params: RequestParams = {}) =>
      this.request<BidDto, MessageResponse>({
        path: `/api/bids`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bids
     * @name UpdateBid
     * @request PUT:/api/bids/{bidId}
     */
    updateBid: (bidId: number, data: UpdateBidDto, params: RequestParams = {}) =>
      this.request<BidDto, MessageResponse>({
        path: `/api/bids/${bidId}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bids
     * @name GetBidById
     * @request GET:/api/bids/{bidId}
     */
    getBidById: (bidId: number, params: RequestParams = {}) =>
      this.request<BidDto, MessageResponse>({
        path: `/api/bids/${bidId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BrokerHousePayments
     * @name CreateBrokerHousePayment
     * @request POST:/api/brokerHousePayments
     */
    createBrokerHousePayment: (data: CreateBrokerHousePaymentDto, params: RequestParams = {}) =>
      this.request<BrokerHousePaymentDto, MessageResponse>({
        path: `/api/brokerHousePayments`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BrokerHousePayments
     * @name UpdateBrokerHousePayment
     * @request PUT:/api/brokerHousePayments/{brokerHousePaymentId}
     */
    updateBrokerHousePayment: (
      brokerHousePaymentId: number,
      data: UpdateBrokerHousePaymentDto,
      params: RequestParams = {},
    ) =>
      this.request<BrokerHousePaymentDto, MessageResponse>({
        path: `/api/brokerHousePayments/${brokerHousePaymentId}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BrokerHousePayments
     * @name GetBrokerHousePaymentById
     * @request GET:/api/brokerHousePayments/{brokerHousePaymentId}
     */
    getBrokerHousePaymentById: (brokerHousePaymentId: number, params: RequestParams = {}) =>
      this.request<BrokerHousePaymentDto, MessageResponse>({
        path: `/api/brokerHousePayments/${brokerHousePaymentId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BrokerHousePayments
     * @name GetAllBrokerHousePayments
     * @request GET:/api/brokerHousePayments/all/{brokerHouseId}
     */
    getAllBrokerHousePayments: (
      brokerHouseId: number,
      query: {
        /** @format int32 */
        Limit: number;
        /** @format int32 */
        Offset: number;
        FilterQuery: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BrokerHousePaymentDtoLazyResponse, any>({
        path: `/api/brokerHousePayments/all/${brokerHouseId}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BrokerHouseReports
     * @name GetBrokerHouseReportYearsDropdown
     * @request GET:/api/reports/brokerHouses/yearsDropdown
     */
    getBrokerHouseReportYearsDropdown: (params: RequestParams = {}) =>
      this.request<DropdownItem[], MessageResponse>({
        path: `/api/reports/brokerHouses/yearsDropdown`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BrokerHouseReports
     * @name GetBrokerHouseReport
     * @request GET:/api/reports/brokerHouses
     */
    getBrokerHouseReport: (
      query: {
        /** @format int32 */
        Limit: number;
        /** @format int32 */
        Offset: number;
        FilterQuery: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BrokerHouseReportDtoLazyResponse, any>({
        path: `/api/reports/brokerHouses`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BrokerHouseReports
     * @name GenerateBrokerHouseReportExcel
     * @request POST:/api/reports/brokerHouses/export
     */
    generateBrokerHouseReportExcel: (
      query: {
        FilterQuery: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BlobPart, any>({format: "arraybuffer",
        path: `/api/reports/brokerHouses/export`,
        method: "POST",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags BrokerHouses
     * @name CreateBrokerHouse
     * @request POST:/api/brokerHouses
     */
    createBrokerHouse: (data: CreateBrokerHouseDto, params: RequestParams = {}) =>
      this.request<BrokerHouseDto, MessageResponse>({
        path: `/api/brokerHouses`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BrokerHouses
     * @name GetAllBrokerHouses
     * @request GET:/api/brokerHouses
     */
    getAllBrokerHouses: (
      query: {
        /** @format int32 */
        Limit: number;
        /** @format int32 */
        Offset: number;
        FilterQuery: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BrokerHouseDtoLazyResponse, any>({
        path: `/api/brokerHouses`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BrokerHouses
     * @name UpdateBrokerHouse
     * @request PUT:/api/brokerHouses/{brokerHouseId}
     */
    updateBrokerHouse: (brokerHouseId: number, data: UpdateBrokerHouseDto, params: RequestParams = {}) =>
      this.request<BrokerHouseDto, MessageResponse>({
        path: `/api/brokerHouses/${brokerHouseId}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BrokerHouses
     * @name DeleteBrokerHouse
     * @request DELETE:/api/brokerHouses/{brokerHouseId}
     */
    deleteBrokerHouse: (brokerHouseId: number, params: RequestParams = {}) =>
      this.request<boolean, MessageResponse>({
        path: `/api/brokerHouses/${brokerHouseId}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BrokerHouses
     * @name GetBrokerHouseById
     * @request GET:/api/brokerHouses/{brokerHouseId}
     */
    getBrokerHouseById: (brokerHouseId: number, params: RequestParams = {}) =>
      this.request<BrokerHouseDto, MessageResponse>({
        path: `/api/brokerHouses/${brokerHouseId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BrokerHouses
     * @name GetAllBrokerHousesDropdown
     * @request GET:/api/brokerHouses/dropdown
     */
    getAllBrokerHousesDropdown: (params: RequestParams = {}) =>
      this.request<DropdownItem[], MessageResponse>({
        path: `/api/brokerHouses/dropdown`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BrokerHouses
     * @name GetAllBrokerHouseMembershipsDropdown
     * @request GET:/api/brokerHouses/membership/dropdown
     */
    getAllBrokerHouseMembershipsDropdown: (params: RequestParams = {}) =>
      this.request<DropdownItem[], MessageResponse>({
        path: `/api/brokerHouses/membership/dropdown`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BrokerHouses
     * @name GetAllBrokerHouseRegionalCentersDropdown
     * @request GET:/api/brokerHouses/regionalCenter/dropdown
     */
    getAllBrokerHouseRegionalCentersDropdown: (params: RequestParams = {}) =>
      this.request<DropdownItem[], MessageResponse>({
        path: `/api/brokerHouses/regionalCenter/dropdown`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BrokerHouses
     * @name GetBrokerHouseHistory
     * @request GET:/api/brokerHouses/{brokerHouseId}/history
     */
    getBrokerHouseHistory: (brokerHouseId: number, params: RequestParams = {}) =>
      this.request<AuditDto[], MessageResponse>({
        path: `/api/brokerHouses/${brokerHouseId}/history`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BrokerHouses
     * @name GetBrokerHouseBrokers
     * @request GET:/api/brokerHouses/{brokerHouseId}/brokers
     */
    getBrokerHouseBrokers: (brokerHouseId: number, params: RequestParams = {}) =>
      this.request<BrokerDto[], MessageResponse>({
        path: `/api/brokerHouses/${brokerHouseId}/brokers`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BrokerOffers
     * @name GetAllOnlineOffers
     * @request GET:/api/broker-offers/online
     */
    getAllOnlineOffers: (params: RequestParams = {}) =>
      this.request<OfferOnlineTableResultDto, MessageResponse>({
        path: `/api/broker-offers/online`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BrokerOffers
     * @name CreateBrokerOffer
     * @request POST:/api/broker-offers
     */
    createBrokerOffer: (data: CreateBrokerOfferDto, params: RequestParams = {}) =>
      this.request<OfferDto, MessageResponse>({
        path: `/api/broker-offers`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BrokerOffers
     * @name GetAllForApprovalBrokerOffers
     * @request GET:/api/broker-offers/forApproval
     */
    getAllForApprovalBrokerOffers: (
      query: {
        /** @format int32 */
        Limit: number;
        /** @format int32 */
        Offset: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BrokerOfferTableDtoLazyResponse, any>({
        path: `/api/broker-offers/forApproval`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BrokerOffers
     * @name GetAllApprovedBrokerOffers
     * @request GET:/api/broker-offers/approved
     */
    getAllApprovedBrokerOffers: (
      query: {
        /** @format int32 */
        Limit: number;
        /** @format int32 */
        Offset: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BrokerOfferTableDtoLazyResponse, any>({
        path: `/api/broker-offers/approved`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BrokerOffers
     * @name GetAllForRejectedBrokerOffers
     * @request GET:/api/broker-offers/rejected
     */
    getAllForRejectedBrokerOffers: (
      query: {
        /** @format int32 */
        Limit: number;
        /** @format int32 */
        Offset: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BrokerOfferTableDtoLazyResponse, any>({
        path: `/api/broker-offers/rejected`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BrokerOffers
     * @name GetBrokerOfferById
     * @request GET:/api/broker-offers/{brokerOfferId}
     */
    getBrokerOfferById: (brokerOfferId: number, params: RequestParams = {}) =>
      this.request<BrokerOfferDto, MessageResponse>({
        path: `/api/broker-offers/${brokerOfferId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BrokerOffers
     * @name UpdateBrokerOffer
     * @request PUT:/api/broker-offers/{brokerOfferId}
     */
    updateBrokerOffer: (brokerOfferId: number, data: BrokerOfferDto, params: RequestParams = {}) =>
      this.request<BrokerOfferDto, MessageResponse>({
        path: `/api/broker-offers/${brokerOfferId}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BrokerOffers
     * @name DeleteBrokerOffer
     * @request DELETE:/api/broker-offers/{brokerOfferId}
     */
    deleteBrokerOffer: (brokerOfferId: number, params: RequestParams = {}) =>
      this.request<boolean, MessageResponse>({
        path: `/api/broker-offers/${brokerOfferId}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BrokerOffers
     * @name RejectBrokerOffer
     * @request PUT:/api/broker-offers/rejectBrokerOffer/{brokerOfferId}
     */
    rejectBrokerOffer: (
      brokerOfferId: number,
      query: {
        rejectReason: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<boolean, MessageResponse>({
        path: `/api/broker-offers/rejectBrokerOffer/${brokerOfferId}`,
        method: "PUT",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BrokerOffers
     * @name ApproveBrokerOffer
     * @request PUT:/api/broker-offers/approveBrokerOffer/{brokerOfferId}
     */
    approveBrokerOffer: (brokerOfferId: number, data: BrokerOfferDto, params: RequestParams = {}) =>
      this.request<boolean, MessageResponse>({
        path: `/api/broker-offers/approveBrokerOffer/${brokerOfferId}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BrokerOffers
     * @name SendBrokerOfferToMail
     * @request POST:/api/broker-offers/sendOfferToMail
     */
    sendBrokerOfferToMail: (data: SendBrokerOfferToMailParameters, params: RequestParams = {}) =>
      this.request<boolean, MessageResponse>({
        path: `/api/broker-offers/sendOfferToMail`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BrokerReports
     * @name GenerateBrokerReport
     * @request GET:/api/reports/brokers
     */
    generateBrokerReport: (
      query: {
        /** @format int32 */
        Limit: number;
        /** @format int32 */
        Offset: number;
        FilterQuery: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BrokerReportDtoLazyResponse, any>({
        path: `/api/reports/brokers`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BrokerReports
     * @name GenerateBrokerReportExcel
     * @request POST:/api/reports/brokers/export
     */
    generateBrokerReportExcel: (
      query: {
        FilterQuery: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BlobPart, any>({format: "arraybuffer",
        path: `/api/reports/brokers/export`,
        method: "POST",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Brokers
     * @name CreateBroker
     * @request POST:/api/brokers
     */
    createBroker: (data: CreateBrokerDto, params: RequestParams = {}) =>
      this.request<BrokerDto, MessageResponse>({
        path: `/api/brokers`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Brokers
     * @name GetAllBrokers
     * @request GET:/api/brokers
     */
    getAllBrokers: (
      query: {
        /** @format int32 */
        Limit: number;
        /** @format int32 */
        Offset: number;
        FilterQuery: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BrokerDtoLazyResponse, any>({
        path: `/api/brokers`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Brokers
     * @name UpdateBroker
     * @request PUT:/api/brokers/{brokerId}
     */
    updateBroker: (brokerId: number, data: UpdateBrokerDto, params: RequestParams = {}) =>
      this.request<BrokerDto, MessageResponse>({
        path: `/api/brokers/${brokerId}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Brokers
     * @name DeleteBroker
     * @request DELETE:/api/brokers/{brokerId}
     */
    deleteBroker: (brokerId: number, params: RequestParams = {}) =>
      this.request<boolean, MessageResponse>({
        path: `/api/brokers/${brokerId}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Brokers
     * @name GetBrokerById
     * @request GET:/api/brokers/{brokerId}
     */
    getBrokerById: (brokerId: number, params: RequestParams = {}) =>
      this.request<BrokerDto, MessageResponse>({
        path: `/api/brokers/${brokerId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Brokers
     * @name GetAllBrokerDropdown
     * @request GET:/api/brokers/dropdown
     */
    getAllBrokerDropdown: (params: RequestParams = {}) =>
      this.request<DropdownItem[], MessageResponse>({
        path: `/api/brokers/dropdown`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Brokers
     * @name GetAllBrokerCodesDropdown
     * @request GET:/api/brokers/codes/dropdown
     */
    getAllBrokerCodesDropdown: (params: RequestParams = {}) =>
      this.request<DropdownItem[], MessageResponse>({
        path: `/api/brokers/codes/dropdown`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Brokers
     * @name GetActiveBrokersSummary
     * @request GET:/api/brokers/summary
     */
    getActiveBrokersSummary: (params: RequestParams = {}) =>
      this.request<BrokerSummaryDto[], MessageResponse>({
        path: `/api/brokers/summary`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Brokers
     * @name GetBrokerHistory
     * @request GET:/api/brokers/{brokerId}/history
     */
    getBrokerHistory: (brokerId: number, params: RequestParams = {}) =>
      this.request<AuditDto[], MessageResponse>({
        path: `/api/brokers/${brokerId}/history`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Brokers
     * @name GetCurrentBrokerDropdown
     * @request GET:/api/brokers/currentBrokerDropdown
     */
    getCurrentBrokerDropdown: (params: RequestParams = {}) =>
      this.request<DropdownItem[], MessageResponse>({
        path: `/api/brokers/currentBrokerDropdown`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BrokersToOnlineOffers
     * @name UpdateBrokersToOnlineOffers
     * @request POST:/api/brokers-to-online-offers/{exchangeWeekId}
     */
    updateBrokersToOnlineOffers: (exchangeWeekId: number, data: Record<string, number[]>, params: RequestParams = {}) =>
      this.request<boolean, MessageResponse>({
        path: `/api/brokers-to-online-offers/${exchangeWeekId}`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BrokersToOnlineOffers
     * @name GetBrokersToOnlineOffers
     * @request GET:/api/brokers-to-online-offers/{exchangeWeekId}
     */
    getBrokersToOnlineOffers: (exchangeWeekId: number, params: RequestParams = {}) =>
      this.request<Record<string, BrokersToOnlineOfferDto>, MessageResponse>({
        path: `/api/brokers-to-online-offers/${exchangeWeekId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Commissions
     * @name CreateCommission
     * @request POST:/api/commissions
     */
    createCommission: (data: CreateCommissionDto, params: RequestParams = {}) =>
      this.request<CommissionDto, MessageResponse>({
        path: `/api/commissions`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Commissions
     * @name GetAllCommissions
     * @request GET:/api/commissions
     */
    getAllCommissions: (
      query: {
        /** @format int32 */
        Limit: number;
        /** @format int32 */
        Offset: number;
        FilterQuery: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CommissionDtoLazyResponse, any>({
        path: `/api/commissions`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Commissions
     * @name UpdateCommission
     * @request PUT:/api/commissions/{commissionId}
     */
    updateCommission: (commissionId: number, data: UpdateCommissionDto, params: RequestParams = {}) =>
      this.request<CommissionDto, MessageResponse>({
        path: `/api/commissions/${commissionId}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Commissions
     * @name DeleteCommission
     * @request DELETE:/api/commissions/{commissionId}
     */
    deleteCommission: (commissionId: number, params: RequestParams = {}) =>
      this.request<boolean, MessageResponse>({
        path: `/api/commissions/${commissionId}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Commissions
     * @name GetCommissionById
     * @request GET:/api/commissions/{commissionId}
     */
    getCommissionById: (commissionId: number, params: RequestParams = {}) =>
      this.request<CommissionDto, MessageResponse>({
        path: `/api/commissions/${commissionId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Commissions
     * @name GetAllCommissionDropdown
     * @request GET:/api/commissions/dropdown
     */
    getAllCommissionDropdown: (params: RequestParams = {}) =>
      this.request<DropdownItem[], MessageResponse>({
        path: `/api/commissions/dropdown`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Commissions
     * @name ChangeCommissionsActiveType
     * @request POST:/api/commissions/changeActiveType/{typeId}
     */
    changeCommissionsActiveType: (typeId: number, params: RequestParams = {}) =>
      this.request<boolean, MessageResponse>({
        path: `/api/commissions/changeActiveType/${typeId}`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Commodities
     * @name CreateCommodity
     * @request POST:/api/commodities
     */
    createCommodity: (data: CreateCommodityDto, params: RequestParams = {}) =>
      this.request<CommodityDto, MessageResponse>({
        path: `/api/commodities`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Commodities
     * @name GetAllCommodities
     * @request GET:/api/commodities
     */
    getAllCommodities: (
      query: {
        /** @format int32 */
        Limit: number;
        /** @format int32 */
        Offset: number;
        FilterQuery: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CommodityDtoLazyResponse, any>({
        path: `/api/commodities`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Commodities
     * @name UpdateCommodity
     * @request PUT:/api/commodities/{commodityId}
     */
    updateCommodity: (commodityId: number, data: UpdateCommodityDto, params: RequestParams = {}) =>
      this.request<CommodityDto, MessageResponse>({
        path: `/api/commodities/${commodityId}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Commodities
     * @name DeleteCommodity
     * @request DELETE:/api/commodities/{commodityId}
     */
    deleteCommodity: (commodityId: number, params: RequestParams = {}) =>
      this.request<boolean, MessageResponse>({
        path: `/api/commodities/${commodityId}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Commodities
     * @name GetCommodityById
     * @request GET:/api/commodities/{commodityId}
     */
    getCommodityById: (commodityId: number, params: RequestParams = {}) =>
      this.request<CommodityDto, MessageResponse>({
        path: `/api/commodities/${commodityId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Commodities
     * @name GetAllCommodityDropdown
     * @request GET:/api/commodities/dropdown/{exchangeCircleId}
     */
    getAllCommodityDropdown: (exchangeCircleId: number, params: RequestParams = {}) =>
      this.request<DropdownItem[], MessageResponse>({
        path: `/api/commodities/dropdown/${exchangeCircleId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Commodities
     * @name GetAllExchangeCirclesDropdown
     * @request GET:/api/commodities/exchangeCircle/dropdown
     */
    getAllExchangeCirclesDropdown: (params: RequestParams = {}) =>
      this.request<DropdownItem[], MessageResponse>({
        path: `/api/commodities/exchangeCircle/dropdown`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Companies
     * @name CreateCompany
     * @request POST:/api/companies
     */
    createCompany: (data: CreateCompanyDto, params: RequestParams = {}) =>
      this.request<CompanyDto, MessageResponse>({
        path: `/api/companies`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Companies
     * @name GetAllCompanies
     * @request GET:/api/companies
     */
    getAllCompanies: (
      query: {
        /** @format int32 */
        Limit: number;
        /** @format int32 */
        Offset: number;
        FilterQuery: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CompanyDtoLazyResponse, any>({
        path: `/api/companies`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Companies
     * @name UpdateCompany
     * @request PUT:/api/companies/{companyId}
     */
    updateCompany: (companyId: number, data: UpdateCompanyDto, params: RequestParams = {}) =>
      this.request<CompanyDto, MessageResponse>({
        path: `/api/companies/${companyId}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Companies
     * @name DeleteCompany
     * @request DELETE:/api/companies/{companyId}
     */
    deleteCompany: (companyId: number, params: RequestParams = {}) =>
      this.request<boolean, MessageResponse>({
        path: `/api/companies/${companyId}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Companies
     * @name GetCompanyById
     * @request GET:/api/companies/{companyId}
     */
    getCompanyById: (companyId: number, params: RequestParams = {}) =>
      this.request<CompanyDto, MessageResponse>({
        path: `/api/companies/${companyId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Companies
     * @name GetAllCompaniesDropdown
     * @request GET:/api/companies/dropdown
     */
    getAllCompaniesDropdown: (params: RequestParams = {}) =>
      this.request<DropdownItem[], MessageResponse>({
        path: `/api/companies/dropdown`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Companies
     * @name GetAllInstitutesDropdown
     * @request GET:/api/companies/institutes/dropdown
     */
    getAllInstitutesDropdown: (params: RequestParams = {}) =>
      this.request<DropdownItem[], MessageResponse>({
        path: `/api/companies/institutes/dropdown`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Companies
     * @name GetCompanyContracts
     * @request GET:/api/companies/getCompanyContracts/{companyId}
     */
    getCompanyContracts: (companyId: number, params: RequestParams = {}) =>
      this.request<CompanyContractsDto, MessageResponse>({
        path: `/api/companies/getCompanyContracts/${companyId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Companies
     * @name GenerateCompanyContractsExcel
     * @request POST:/api/companies/generateExcel/{companyId}
     */
    generateCompanyContractsExcel: (companyId: number, params: RequestParams = {}) =>
      this.request<BlobPart, any>({format: "arraybuffer",
        path: `/api/companies/generateExcel/${companyId}`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ContractReports
     * @name GetContractReport
     * @request GET:/api/reports/contracts
     */
    getContractReport: (
      query: {
        /** @format int32 */
        Limit: number;
        /** @format int32 */
        Offset: number;
        FilterQuery: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ContractReportDtoLazyResponse, any>({
        path: `/api/reports/contracts`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ContractReports
     * @name GenerateContractReportExcel
     * @request POST:/api/reports/contracts/export
     */
    generateContractReportExcel: (
      query: {
        FilterQuery: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BlobPart, any>({format: "arraybuffer",
        path: `/api/reports/contracts/export`,
        method: "POST",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contracts
     * @name CreateAndUpdateContractsWithCommodities
     * @request POST:/api/contracts/{offerId}
     */
    createAndUpdateContractsWithCommodities: (
      offerId: number,
      data: CreateContractWithCommodityRequest,
      params: RequestParams = {},
    ) =>
      this.request<ContractDto, MessageResponse>({
        path: `/api/contracts/${offerId}`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contracts
     * @name AnnulContract
     * @request PUT:/api/contracts/annulContract/{contractId}
     */
    annulContract: (contractId: number, params: RequestParams = {}) =>
      this.request<boolean, MessageResponse>({
        path: `/api/contracts/annulContract/${contractId}`,
        method: "PUT",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contracts
     * @name DeleteContract
     * @request DELETE:/api/contracts/{contractId}
     */
    deleteContract: (contractId: number, params: RequestParams = {}) =>
      this.request<boolean, MessageResponse>({
        path: `/api/contracts/${contractId}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contracts
     * @name GetAllContractsForOffer
     * @request GET:/api/contracts/forOffer/{offerId}
     */
    getAllContractsForOffer: (offerId: number, params: RequestParams = {}) =>
      this.request<CreateContractWithCommodityDto[], MessageResponse>({
        path: `/api/contracts/forOffer/${offerId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contracts
     * @name DoesContractNumberExits
     * @request GET:/api/contracts/doesNumberExist/{contractNumber}
     */
    doesContractNumberExits: (contractNumber: string, params: RequestParams = {}) =>
      this.request<boolean, MessageResponse>({
        path: `/api/contracts/doesNumberExist/${contractNumber}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CpvCodes
     * @name CreateCpvCode
     * @request POST:/api/cpvCodes
     */
    createCpvCode: (data: CreateCpvCodeDto, params: RequestParams = {}) =>
      this.request<CpvCodeDto, MessageResponse>({
        path: `/api/cpvCodes`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CpvCodes
     * @name GetAllCpvCodes
     * @request GET:/api/cpvCodes
     */
    getAllCpvCodes: (
      query: {
        /** @format int32 */
        Limit: number;
        /** @format int32 */
        Offset: number;
        FilterQuery: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CpvCodeDtoLazyResponse, any>({
        path: `/api/cpvCodes`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CpvCodes
     * @name UpdateCpvCode
     * @request PUT:/api/cpvCodes/{cpvCodeId}
     */
    updateCpvCode: (cpvCodeId: number, data: UpdateCpvCodeDto, params: RequestParams = {}) =>
      this.request<CpvCodeDto, MessageResponse>({
        path: `/api/cpvCodes/${cpvCodeId}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CpvCodes
     * @name DeleteCpvCode
     * @request DELETE:/api/cpvCodes/{cpvCodeId}
     */
    deleteCpvCode: (cpvCodeId: number, params: RequestParams = {}) =>
      this.request<boolean, MessageResponse>({
        path: `/api/cpvCodes/${cpvCodeId}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CpvCodes
     * @name GetCpvCodeById
     * @request GET:/api/cpvCodes/{cpvCodeId}
     */
    getCpvCodeById: (cpvCodeId: number, params: RequestParams = {}) =>
      this.request<CpvCodeDto, MessageResponse>({
        path: `/api/cpvCodes/${cpvCodeId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CpvCodes
     * @name GetAllCpvCodeDropdown
     * @request GET:/api/cpvCodes/dropdown
     */
    getAllCpvCodeDropdown: (params: RequestParams = {}) =>
      this.request<DropdownItem[], MessageResponse>({
        path: `/api/cpvCodes/dropdown`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CurrencyRateReports
     * @name GenerateCurrencyRateReport
     * @request GET:/api/reports/currencyRates
     */
    generateCurrencyRateReport: (
      query: {
        /** @format int32 */
        Limit: number;
        /** @format int32 */
        Offset: number;
        FilterQuery: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CurrencyRateReportDtoLazyResponse, any>({
        path: `/api/reports/currencyRates`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CurrencyRateReports
     * @name GenerateCurrencyRateReportExcel
     * @request POST:/api/reports/currencyRates/export
     */
    generateCurrencyRateReportExcel: (
      query: {
        FilterQuery: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BlobPart, any>({format: "arraybuffer",
        path: `/api/reports/currencyRates/export`,
        method: "POST",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags CurrencyRates
     * @name UpdateCurrencyRate
     * @request PUT:/api/currencyRates/{currencyRateId}
     */
    updateCurrencyRate: (currencyRateId: number, data: UpdateCurrencyRateDto, params: RequestParams = {}) =>
      this.request<CurrencyRateDto, MessageResponse>({
        path: `/api/currencyRates/${currencyRateId}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CurrencyRates
     * @name DeleteCurrencyRate
     * @request DELETE:/api/currencyRates/{currencyRateId}
     */
    deleteCurrencyRate: (currencyRateId: number, params: RequestParams = {}) =>
      this.request<boolean, MessageResponse>({
        path: `/api/currencyRates/${currencyRateId}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CurrencyRates
     * @name GetCurrencyRateById
     * @request GET:/api/currencyRates/{currencyRateId}
     */
    getCurrencyRateById: (currencyRateId: number, params: RequestParams = {}) =>
      this.request<CurrencyRateDto, MessageResponse>({
        path: `/api/currencyRates/${currencyRateId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CurrencyRates
     * @name GetAllCurrencyRates
     * @request GET:/api/currencyRates
     */
    getAllCurrencyRates: (
      query: {
        /** @format int32 */
        Limit: number;
        /** @format int32 */
        Offset: number;
        FilterQuery: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CurrencyRateDtoLazyResponse, any>({
        path: `/api/currencyRates`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CurrencyRates
     * @name GetAllCurrencyRateDropdown
     * @request GET:/api/currencyRates/dropdown
     */
    getAllCurrencyRateDropdown: (params: RequestParams = {}) =>
      this.request<DropdownItem[], MessageResponse>({
        path: `/api/currencyRates/dropdown`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CurrencyRates
     * @name GetAllCurrenciesDropdown
     * @request GET:/api/currencyRates/currency/dropdown
     */
    getAllCurrenciesDropdown: (params: RequestParams = {}) =>
      this.request<DropdownItem[], MessageResponse>({
        path: `/api/currencyRates/currency/dropdown`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DailyDealsReports
     * @name GetDailyDealsReport
     * @request GET:/api/reports/predefined/daily
     */
    getDailyDealsReport: (
      query: {
        /** @format int32 */
        Limit: number;
        /** @format int32 */
        Offset: number;
        FilterQuery: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<DailyDealsReportDtoLazyResponse, any>({
        path: `/api/reports/predefined/daily`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DailyDealsReports
     * @name GenerateDailyDealsReportExcel
     * @request POST:/api/reports/predefined/daily/export
     */
    generateDailyDealsReportExcel: (
      query: {
        FilterQuery: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BlobPart, any>({format: "arraybuffer",
        path: `/api/reports/predefined/daily/export`,
        method: "POST",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags DealReports
     * @name GenerateDealReport
     * @request GET:/api/reports/deals
     */
    generateDealReport: (
      query: {
        /** @format int32 */
        Limit: number;
        /** @format int32 */
        Offset: number;
        FilterQuery: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<DealReportDtoLazyResponse, any>({
        path: `/api/reports/deals`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DealReports
     * @name GenerateDealReportExcel
     * @request POST:/api/reports/deals/export
     */
    generateDealReportExcel: (
      query: {
        FilterQuery: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BlobPart, any>({format: "arraybuffer",
        path: `/api/reports/deals/export`,
        method: "POST",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Deals
     * @name CreateAndUpdateDealsWithCommodities
     * @request POST:/api/deals/{offerId}
     */
    createAndUpdateDealsWithCommodities: (
      offerId: number,
      data: CreateDealWithCommodityRequest,
      params: RequestParams = {},
    ) =>
      this.request<DealDto, MessageResponse>({
        path: `/api/deals/${offerId}`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Deals
     * @name GetAllDealsForOffer
     * @request GET:/api/deals/forOffer/{offerId}
     */
    getAllDealsForOffer: (offerId: number, params: RequestParams = {}) =>
      this.request<CreateDealWithCommodityDto[], MessageResponse>({
        path: `/api/deals/forOffer/${offerId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Deals
     * @name GetAllDealsDropdownForOffer
     * @request GET:/api/deals/forOffer/{offerId}/dropdown
     */
    getAllDealsDropdownForOffer: (offerId: number, params: RequestParams = {}) =>
      this.request<DropdownItem[], MessageResponse>({
        path: `/api/deals/forOffer/${offerId}/dropdown`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Deals
     * @name GetDealsForTicket
     * @request POST:/api/deals/forTickets
     */
    getDealsForTicket: (data: number[], params: RequestParams = {}) =>
      this.request<DealDto[], MessageResponse>({
        path: `/api/deals/forTickets`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Deals
     * @name DeleteDeal
     * @request DELETE:/api/deals/{dealId}
     */
    deleteDeal: (dealId: number, params: RequestParams = {}) =>
      this.request<boolean, MessageResponse>({
        path: `/api/deals/${dealId}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DeliveryTimes
     * @name CreateDeliveryTime
     * @request POST:/api/deliveryTimes
     */
    createDeliveryTime: (data: CreateDeliveryTimeDto, params: RequestParams = {}) =>
      this.request<DeliveryTimeDto, MessageResponse>({
        path: `/api/deliveryTimes`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DeliveryTimes
     * @name GetAllDeliveryTimes
     * @request GET:/api/deliveryTimes
     */
    getAllDeliveryTimes: (
      query: {
        /** @format int32 */
        Limit: number;
        /** @format int32 */
        Offset: number;
        FilterQuery: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<DeliveryTimeDtoLazyResponse, any>({
        path: `/api/deliveryTimes`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DeliveryTimes
     * @name UpdateDeliveryTime
     * @request PUT:/api/deliveryTimes/{deliveryTimeId}
     */
    updateDeliveryTime: (deliveryTimeId: number, data: UpdateDeliveryTimeDto, params: RequestParams = {}) =>
      this.request<DeliveryTimeDto, MessageResponse>({
        path: `/api/deliveryTimes/${deliveryTimeId}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DeliveryTimes
     * @name DeleteDeliveryTime
     * @request DELETE:/api/deliveryTimes/{deliveryTimeId}
     */
    deleteDeliveryTime: (deliveryTimeId: number, params: RequestParams = {}) =>
      this.request<boolean, MessageResponse>({
        path: `/api/deliveryTimes/${deliveryTimeId}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DeliveryTimes
     * @name GetDeliveryTimeById
     * @request GET:/api/deliveryTimes/{deliveryTimeId}
     */
    getDeliveryTimeById: (deliveryTimeId: number, params: RequestParams = {}) =>
      this.request<DeliveryTimeDto, MessageResponse>({
        path: `/api/deliveryTimes/${deliveryTimeId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DeliveryTimes
     * @name GetAllDeliveryTimeDropdown
     * @request GET:/api/deliveryTimes/dropdown
     */
    getAllDeliveryTimeDropdown: (params: RequestParams = {}) =>
      this.request<DropdownItem[], MessageResponse>({
        path: `/api/deliveryTimes/dropdown`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DemoSession
     * @name StartDemoSession
     * @request POST:/api/session/demo/start/{startDate}/{endDate}
     */
    startDemoSession: (startDate: string, endDate: string, params: RequestParams = {}) =>
      this.request<boolean, MessageResponse>({
        path: `/api/session/demo/start/${startDate}/${endDate}`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DemoSession
     * @name StopDemoSession
     * @request POST:/api/session/demo/stop
     */
    stopDemoSession: (params: RequestParams = {}) =>
      this.request<boolean, MessageResponse>({
        path: `/api/session/demo/stop`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DemoSession
     * @name IsDemoSessionLive
     * @request GET:/api/session/demo/isLive
     */
    isDemoSessionLive: (params: RequestParams = {}) =>
      this.request<boolean, MessageResponse>({
        path: `/api/session/demo/isLive`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExchangeSession
     * @name CreateExchangeSession
     * @request POST:/api/exchange-sessions
     */
    createExchangeSession: (data: CreateExchangeSessionDto, params: RequestParams = {}) =>
      this.request<ExchangeSessionDto, MessageResponse>({
        path: `/api/exchange-sessions`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExchangeSession
     * @name GetAllExchangeSessionsInfos
     * @request GET:/api/exchange-sessions
     */
    getAllExchangeSessionsInfos: (params: RequestParams = {}) =>
      this.request<Record<string, ExchangeSessionDto[]>, MessageResponse>({
        path: `/api/exchange-sessions`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExchangeSession
     * @name GetExchangeInfoById
     * @request GET:/api/exchange-sessions/{exchangeSessionId}
     */
    getExchangeInfoById: (exchangeSessionId: number, params: RequestParams = {}) =>
      this.request<ExchangeSessionDto, MessageResponse>({
        path: `/api/exchange-sessions/${exchangeSessionId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExchangeSession
     * @name AddBrokerToExchangeSession
     * @request POST:/api/exchange-sessions/addBroker/{exchangeSessionId}/{brokerId}
     */
    addBrokerToExchangeSession: (exchangeSessionId: number, brokerId: number, params: RequestParams = {}) =>
      this.request<boolean, MessageResponse>({
        path: `/api/exchange-sessions/addBroker/${exchangeSessionId}/${brokerId}`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExchangeSession
     * @name RemoveBrokerFromExchangeSession
     * @request DELETE:/api/exchange-sessions/deleteBroker/{exchangeSessionId}/{brokerId}
     */
    removeBrokerFromExchangeSession: (exchangeSessionId: number, brokerId: number, params: RequestParams = {}) =>
      this.request<boolean, MessageResponse>({
        path: `/api/exchange-sessions/deleteBroker/${exchangeSessionId}/${brokerId}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExchangeSession
     * @name HideExchangeSession
     * @request PUT:/api/exchange-sessions/hideSession/{exchangeSessionId}
     */
    hideExchangeSession: (exchangeSessionId: number, params: RequestParams = {}) =>
      this.request<boolean, MessageResponse>({
        path: `/api/exchange-sessions/hideSession/${exchangeSessionId}`,
        method: "PUT",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExchangeSession
     * @name GetLiveSessionInfo
     * @request GET:/api/exchange-sessions/liveSessionInfo
     */
    getLiveSessionInfo: (params: RequestParams = {}) =>
      this.request<LiveSessionInfoDto, MessageResponse>({
        path: `/api/exchange-sessions/liveSessionInfo`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExchangeWeek
     * @name GetExchangeWeekById
     * @request GET:/api/exchange-weeks/{exchangeWeekId}
     */
    getExchangeWeekById: (exchangeWeekId: number, params: RequestParams = {}) =>
      this.request<ExchangeWeekEntity, MessageResponse>({
        path: `/api/exchange-weeks/${exchangeWeekId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags GuaranteeDeposits
     * @name CreateGuaranteeDeposit
     * @request POST:/api/guaranteeDeposits
     */
    createGuaranteeDeposit: (data: CreateGuaranteeDepositDto, params: RequestParams = {}) =>
      this.request<GuaranteeDepositDto, MessageResponse>({
        path: `/api/guaranteeDeposits`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags GuaranteeDeposits
     * @name GetAllGuaranteeDeposits
     * @request GET:/api/guaranteeDeposits
     */
    getAllGuaranteeDeposits: (
      query: {
        /** @format int32 */
        Limit: number;
        /** @format int32 */
        Offset: number;
        FilterQuery: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GuaranteeDepositDtoStringDecimalDictionaryLazyResponse, any>({
        path: `/api/guaranteeDeposits`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags GuaranteeDeposits
     * @name UpdateGuaranteeDeposit
     * @request PUT:/api/guaranteeDeposits/{guaranteeDepositId}
     */
    updateGuaranteeDeposit: (guaranteeDepositId: number, data: UpdateGuaranteeDepositDto, params: RequestParams = {}) =>
      this.request<GuaranteeDepositDto, MessageResponse>({
        path: `/api/guaranteeDeposits/${guaranteeDepositId}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags GuaranteeDeposits
     * @name DeleteGuaranteeDeposit
     * @request DELETE:/api/guaranteeDeposits/{guaranteeDepositId}
     */
    deleteGuaranteeDeposit: (guaranteeDepositId: number, params: RequestParams = {}) =>
      this.request<boolean, MessageResponse>({
        path: `/api/guaranteeDeposits/${guaranteeDepositId}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags GuaranteeDeposits
     * @name GetGuaranteeDepositById
     * @request GET:/api/guaranteeDeposits/{guaranteeDepositId}
     */
    getGuaranteeDepositById: (guaranteeDepositId: number, params: RequestParams = {}) =>
      this.request<GuaranteeDepositDto, MessageResponse>({
        path: `/api/guaranteeDeposits/${guaranteeDepositId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags GuaranteeDeposits
     * @name GenerateGuaranteeDepositsExcel
     * @request POST:/api/guaranteeDeposits/generateExcel
     */
    generateGuaranteeDepositsExcel: (
      query: {
        filterQuery: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BlobPart, any>({format: "arraybuffer",
        path: `/api/guaranteeDeposits/generateExcel`,
        method: "POST",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Measurements
     * @name CreateMeasurement
     * @request POST:/api/measurements
     */
    createMeasurement: (data: CreateMeasurementDto, params: RequestParams = {}) =>
      this.request<MeasurementDto, MessageResponse>({
        path: `/api/measurements`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Measurements
     * @name GetAllMeasurements
     * @request GET:/api/measurements
     */
    getAllMeasurements: (
      query: {
        /** @format int32 */
        Limit: number;
        /** @format int32 */
        Offset: number;
        FilterQuery: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MeasurementDtoLazyResponse, any>({
        path: `/api/measurements`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Measurements
     * @name UpdateMeasurement
     * @request PUT:/api/measurements/{measurementId}
     */
    updateMeasurement: (measurementId: number, data: UpdateMeasurementDto, params: RequestParams = {}) =>
      this.request<MeasurementDto, MessageResponse>({
        path: `/api/measurements/${measurementId}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Measurements
     * @name DeleteMeasurement
     * @request DELETE:/api/measurements/{measurementId}
     */
    deleteMeasurement: (measurementId: number, params: RequestParams = {}) =>
      this.request<boolean, MessageResponse>({
        path: `/api/measurements/${measurementId}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Measurements
     * @name GetMeasurementById
     * @request GET:/api/measurements/{measurementId}
     */
    getMeasurementById: (measurementId: number, params: RequestParams = {}) =>
      this.request<MeasurementDto, MessageResponse>({
        path: `/api/measurements/${measurementId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Measurements
     * @name GetAllMeasurementDropdown
     * @request GET:/api/measurements/dropdown
     */
    getAllMeasurementDropdown: (params: RequestParams = {}) =>
      this.request<DropdownItem[], MessageResponse>({
        path: `/api/measurements/dropdown`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MegaReports
     * @name GenerateMegaReport
     * @request GET:/api/reports/mega
     */
    generateMegaReport: (
      query: {
        /** @format int32 */
        Limit: number;
        /** @format int32 */
        Offset: number;
        FilterQuery: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MegaReportDtoLazyResponse, any>({
        path: `/api/reports/mega`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MegaReports
     * @name GenerateMegaReportExcel
     * @request POST:/api/reports/mega/export
     */
    generateMegaReportExcel: (
      query: {
        FilterQuery: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BlobPart, any>({format: "arraybuffer",
        path: `/api/reports/mega/export`,
        method: "POST",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags MonthlyReports
     * @name GenerateMonthlyReport
     * @request GET:/api/reports/predefined/monthly/{year}/{month}
     */
    generateMonthlyReport: (year: number, month: number, params: RequestParams = {}) =>
      this.request<MonthlyReportDto[], any>({
        path: `/api/reports/predefined/monthly/${year}/${month}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MonthlyReports
     * @name GenerateMonthlyReportExcel
     * @request POST:/api/reports/predefined/monthly/export
     */
    generateMonthlyReportExcel: (
      query: {
        /** @format int32 */
        Year: number;
        /** @format int32 */
        Month: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BlobPart, any>({format: "arraybuffer",
        path: `/api/reports/predefined/monthly/export`,
        method: "POST",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags OfferReports
     * @name GenerateOffersOffersReportExcel
     * @request POST:/api/offers/reports/offersReport/{exchangeCircleId}
     */
    generateOffersOffersReportExcel: (exchangeCircleId: number, data: number[], params: RequestParams = {}) =>
      this.request<BlobPart, any>({format: "arraybuffer",
        path: `/api/offers/reports/offersReport/${exchangeCircleId}`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags OfferReports
     * @name GenerateOffersBrokersReportExcel
     * @request POST:/api/offers/reports/brokersReport/{exchangeCircleId}/{year}/{week}
     */
    generateOffersBrokersReportExcel: (
      exchangeCircleId: number,
      year: number,
      week: number,
      data: number[],
      params: RequestParams = {},
    ) =>
      this.request<BlobPart, any>({format: "arraybuffer",
        path: `/api/offers/reports/brokersReport/${exchangeCircleId}/${year}/${week}`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags OfferReports
     * @name GenerateOffersQuoterReportExcel
     * @request POST:/api/offers/reports/quoterReport/{exchangeCircleId}/{year}/{week}
     */
    generateOffersQuoterReportExcel: (
      year: number,
      week: number,
      exchangeCircleId: number,
      data: number[],
      params: RequestParams = {},
    ) =>
      this.request<BlobPart, any>({format: "arraybuffer",
        path: `/api/offers/reports/quoterReport/${exchangeCircleId}/${year}/${week}`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags OfferReports
     * @name GenerateOffersQuoterSessionExcel
     * @request POST:/api/offers/reports/quoterSession/{exchangeCircleId}/{year}/{week}
     */
    generateOffersQuoterSessionExcel: (
      year: number,
      week: number,
      exchangeCircleId: number,
      data: number[],
      params: RequestParams = {},
    ) =>
      this.request<BlobPart, any>({format: "arraybuffer",
        path: `/api/offers/reports/quoterSession/${exchangeCircleId}/${year}/${week}`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags OfferReports
     * @name GetOfferReport
     * @request GET:/api/reports/offers
     */
    getOfferReport: (
      query: {
        /** @format int32 */
        Limit: number;
        /** @format int32 */
        Offset: number;
        FilterQuery: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<OfferReportDtoLazyResponse, any>({
        path: `/api/reports/offers`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OfferReports
     * @name GenerateOfferReportExcel
     * @request POST:/api/reports/offers/export
     */
    generateOfferReportExcel: (
      query: {
        FilterQuery: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BlobPart, any>({format: "arraybuffer",
        path: `/api/reports/offers/export`,
        method: "POST",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Offers
     * @name GetAllOffers
     * @request GET:/api/offers
     */
    getAllOffers: (
      query: {
        /** @format int32 */
        week: number;
        /** @format int32 */
        year: number;
        offersWith?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<OfferTablesResultDto, any>({
        path: `/api/offers`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Offers
     * @name CreateOffer
     * @request POST:/api/offers
     */
    createOffer: (data: CreateOfferDto, params: RequestParams = {}) =>
      this.request<OfferDto, MessageResponse>({
        path: `/api/offers`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Offers
     * @name DeleteOffers
     * @request DELETE:/api/offers
     */
    deleteOffers: (data: number[], params: RequestParams = {}) =>
      this.request<boolean, MessageResponse>({
        path: `/api/offers`,
        method: "DELETE",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Offers
     * @name UpdateOffer
     * @request PUT:/api/offers/{offerId}
     */
    updateOffer: (offerId: number, data: UpdateOfferDto, params: RequestParams = {}) =>
      this.request<OfferDto, MessageResponse>({
        path: `/api/offers/${offerId}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Offers
     * @name GetOfferById
     * @request GET:/api/offers/{offerId}
     */
    getOfferById: (offerId: number, params: RequestParams = {}) =>
      this.request<OfferDto, MessageResponse>({
        path: `/api/offers/${offerId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Offers
     * @name GetOffersCounts
     * @request GET:/api/offers/count
     */
    getOffersCounts: (
      query: {
        /** @format int32 */
        week: number;
        /** @format int32 */
        year: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<OffersCountDto, any>({
        path: `/api/offers/count`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Offers
     * @name GetOfferCounts
     * @request GET:/api/offers/{offerId}/count
     */
    getOfferCounts: (offerId: number, params: RequestParams = {}) =>
      this.request<OffersCountDto, any>({
        path: `/api/offers/${offerId}/count`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Offers
     * @name GetOfferTypesDropdown
     * @request GET:/api/offers/offer-types/dropdown
     */
    getOfferTypesDropdown: (params: RequestParams = {}) =>
      this.request<DropdownItem[], MessageResponse>({
        path: `/api/offers/offer-types/dropdown`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Offers
     * @name ArchiveOffers
     * @request POST:/api/offers/archive
     */
    archiveOffers: (data: number[], params: RequestParams = {}) =>
      this.request<boolean, MessageResponse>({
        path: `/api/offers/archive`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Offers
     * @name AllowOffersForOnlineTrading
     * @request POST:/api/offers/allowOnlineTrading
     */
    allowOffersForOnlineTrading: (data: number[], params: RequestParams = {}) =>
      this.request<boolean, MessageResponse>({
        path: `/api/offers/allowOnlineTrading`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Offers
     * @name ForbidOffersForOnlineTrading
     * @request POST:/api/offers/forbidOnlineTrading
     */
    forbidOffersForOnlineTrading: (data: number[], params: RequestParams = {}) =>
      this.request<boolean, MessageResponse>({
        path: `/api/offers/forbidOnlineTrading`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Offers
     * @name OfferCommoditiesDropdown
     * @request GET:/api/offers/offerCommoditiesDropdown/{offerId}
     */
    offerCommoditiesDropdown: (offerId: number, params: RequestParams = {}) =>
      this.request<DropdownItem[], MessageResponse>({
        path: `/api/offers/offerCommoditiesDropdown/${offerId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Offers
     * @name DeleteOfferCommodity
     * @request DELETE:/api/offers/offerCommodities/{offerCommodityId}
     */
    deleteOfferCommodity: (offerCommodityId: number, params: RequestParams = {}) =>
      this.request<boolean, MessageResponse>({
        path: `/api/offers/offerCommodities/${offerCommodityId}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Offers
     * @name GetAllBrokerOffersForApproval
     * @request GET:/api/offers/forApproval
     */
    getAllBrokerOffersForApproval: (params: RequestParams = {}) =>
      this.request<BrokerOfferForApprovalTableResultDto, MessageResponse>({
        path: `/api/offers/forApproval`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OldContractReports
     * @name GenerateOldContractsReport
     * @request GET:/api/reports/oldContracts
     */
    generateOldContractsReport: (
      query: {
        /** @format int32 */
        Limit: number;
        /** @format int32 */
        Offset: number;
        FilterQuery: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<OldContractReportDtoLazyResponse, any>({
        path: `/api/reports/oldContracts`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OldContractReports
     * @name GenerateOldContractsReportExcel
     * @request POST:/api/reports/oldContracts/export
     */
    generateOldContractsReportExcel: (
      query: {
        FilterQuery: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BlobPart, any>({format: "arraybuffer",
        path: `/api/reports/oldContracts/export`,
        method: "POST",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags OnlineExchangeSession
     * @name CreateOnlineExchangeSession
     * @request POST:/api/online-exchange-sessions
     */
    createOnlineExchangeSession: (data: CreateExchangeSessionDto, params: RequestParams = {}) =>
      this.request<ExchangeSessionDto, MessageResponse>({
        path: `/api/online-exchange-sessions`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OnlineExchangeSession
     * @name GetAllOnlineExchangeSessions
     * @request GET:/api/online-exchange-sessions
     */
    getAllOnlineExchangeSessions: (params: RequestParams = {}) =>
      this.request<Record<string, ExchangeSessionDto[]>, MessageResponse>({
        path: `/api/online-exchange-sessions`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OnlineExchangeSession
     * @name GetOffersAllowedForOnlineTradingForExchangeWeek
     * @request GET:/api/online-exchange-sessions/{exchangeWeekId}/offers
     */
    getOffersAllowedForOnlineTradingForExchangeWeek: (exchangeWeekId: number, params: RequestParams = {}) =>
      this.request<OfferSummaryDto[], MessageResponse>({
        path: `/api/online-exchange-sessions/${exchangeWeekId}/offers`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OnlineSession
     * @name HandleSubmitterDecision
     * @request POST:/api/online-session/submitter-decision
     */
    handleSubmitterDecision: (data: OnlineSessionSubmitterDecisionDto, params: RequestParams = {}) =>
      this.request<boolean, MessageResponse>({
        path: `/api/online-session/submitter-decision`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OnlineSessionEvent
     * @name GetEventsForSession
     * @request GET:/api/online-session-events/{exchangeSessionId}
     */
    getEventsForSession: (exchangeSessionId: number, params: RequestParams = {}) =>
      this.request<OnlineSessionEventEntity[], MessageResponse>({
        path: `/api/online-session-events/${exchangeSessionId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags OnlineSessionEvent
     * @name GetBrokerEventsForSession
     * @request GET:/api/online-session-events/broker-events/{exchangeSessionId}
     */
    getBrokerEventsForSession: (params: RequestParams = {}) =>
      this.request<OnlineSessionEventEntity[], MessageResponse>({
        path: `/api/online-session-events/broker-events`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProtocolsReports
     * @name GetProtocolsReport
     * @request GET:/api/reports/predefined/protocols
     */
    getProtocolsReport: (params: RequestParams = {}) =>
      this.request<ProtocolsReportDto[], any>({
        path: `/api/reports/predefined/protocols`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProtocolsReports
     * @name GenerateProtocolsReportExcel
     * @request POST:/api/reports/predefined/protocols/{exchangeCircleId}/export
     */
    generateProtocolsReportExcel: (exchangeCircleId: number, params: RequestParams = {}) =>
      this.request<BlobPart, any>({format: "arraybuffer",
        path: `/api/reports/predefined/protocols/${exchangeCircleId}/export`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RegistryOfficeBrokerHouseReports
     * @name GenerateRegistryOfficeBrokerHouseReport
     * @request GET:/api/reports/registryOffice/brokerHouses
     */
    generateRegistryOfficeBrokerHouseReport: (
      query: {
        /** @format int32 */
        Limit: number;
        /** @format int32 */
        Offset: number;
        FilterQuery: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<RegistryOfficeBrokerHouseReportDtoLazyResponse, any>({
        path: `/api/reports/registryOffice/brokerHouses`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RegistryOfficeBrokerHouseReports
     * @name GenerateRegistryOfficeBrokerHouseReportExcel
     * @request POST:/api/reports/registryOffice/brokerHouses/export
     */
    generateRegistryOfficeBrokerHouseReportExcel: (
      query: {
        FilterQuery: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BlobPart, any>({format: "arraybuffer",
        path: `/api/reports/registryOffice/brokerHouses/export`,
        method: "POST",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags RegistryOfficeBrokerReports
     * @name GenerateRegistryOfficeBrokerReport
     * @request GET:/api/reports/registryOffice/brokers
     */
    generateRegistryOfficeBrokerReport: (
      query: {
        /** @format int32 */
        Limit: number;
        /** @format int32 */
        Offset: number;
        FilterQuery: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<RegistryOfficeBrokerReportDtoLazyResponse, any>({
        path: `/api/reports/registryOffice/brokers`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags RegistryOfficeBrokerReports
     * @name GenerateRegistryOfficeBrokerReportExcel
     * @request POST:/api/reports/registryOffice/brokers/export
     */
    generateRegistryOfficeBrokerReportExcel: (
      query: {
        FilterQuery: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BlobPart, any>({format: "arraybuffer",
        path: `/api/reports/registryOffice/brokers/export`,
        method: "POST",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Session
     * @name GetSessionOfferOptions
     * @request GET:/api/session/{exchangeSessionId}/offer-options
     */
    getSessionOfferOptions: (exchangeSessionId: number, params: RequestParams = {}) =>
      this.request<SessionOfferOptionsDto, MessageResponse>({
        path: `/api/session/${exchangeSessionId}/offer-options`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Session
     * @name GetSessionDetails
     * @request GET:/api/session/{exchangeSessionId}/{offerId}/details
     */
    getSessionDetails: (exchangeSessionId: number, offerId: number, params: RequestParams = {}) =>
      this.request<SessionDetailsDto, MessageResponse>({
        path: `/api/session/${exchangeSessionId}/${offerId}/details`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Session
     * @name CreateSessionDeal
     * @request POST:/api/session/{exchangeSessionId}/{offerId}/deal
     */
    createSessionDeal: (exchangeSessionId: number, offerId: number, params: RequestParams = {}) =>
      this.request<boolean, MessageResponse>({
        path: `/api/session/${exchangeSessionId}/${offerId}/deal`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Session
     * @name ToggleLiveSession
     * @request POST:/api/session/{exchangeSessionId}/{offerId}/toggleLive/{isLive}
     */
    toggleLiveSession: (exchangeSessionId: number, offerId: number, isLive: boolean, params: RequestParams = {}) =>
      this.request<boolean, MessageResponse>({
        path: `/api/session/${exchangeSessionId}/${offerId}/toggleLive/${isLive}`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Session
     * @name StopLiveSession
     * @request POST:/api/session/{exchangeSessionId}/stopLiveSession
     */
    stopLiveSession: (exchangeSessionId: number, params: RequestParams = {}) =>
      this.request<boolean, MessageResponse>({
        path: `/api/session/${exchangeSessionId}/stopLiveSession`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Session
     * @name TakeSessionControl
     * @request POST:/api/session/{exchangeSessionId}/takeSessionControl
     */
    takeSessionControl: (exchangeSessionId: number, params: RequestParams = {}) =>
      this.request<boolean, MessageResponse>({
        path: `/api/session/${exchangeSessionId}/takeSessionControl`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tickets
     * @name UpdateTicketsForOffer
     * @request POST:/api/tickets/{offerId}
     */
    updateTicketsForOffer: (offerId: number, data: TicketDto[], params: RequestParams = {}) =>
      this.request<TicketDto[], MessageResponse>({
        path: `/api/tickets/${offerId}`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tickets
     * @name GetTicketsForOffer
     * @request GET:/api/tickets/forOffer/{offerId}
     */
    getTicketsForOffer: (offerId: number, params: RequestParams = {}) =>
      this.request<TicketDto[], MessageResponse>({
        path: `/api/tickets/forOffer/${offerId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tickets
     * @name GetTicketsDropdownForOffer
     * @request GET:/api/tickets/forOffer/{offerId}/dropdown
     */
    getTicketsDropdownForOffer: (offerId: number, params: RequestParams = {}) =>
      this.request<DropdownItem[], MessageResponse>({
        path: `/api/tickets/forOffer/${offerId}/dropdown`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tickets
     * @name GetTicketsDropdownForOfferAndDeal
     * @request POST:/api/tickets/forOffer/{offerId}/dropdown
     */
    getTicketsDropdownForOfferAndDeal: (offerId: number, data: number[], params: RequestParams = {}) =>
      this.request<DropdownItem[], MessageResponse>({
        path: `/api/tickets/forOffer/${offerId}/dropdown`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tickets
     * @name GenerateTicketPdf
     * @request GET:/api/tickets/{ticketId}/print
     */
    generateTicketPdf: (ticketId: number, params: RequestParams = {}) =>
      this.request<BlobPart, any>({format: "arraybuffer",
        path: `/api/tickets/${ticketId}/print`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tickets
     * @name DeleteTicket
     * @request DELETE:/api/tickets/{ticketId}
     */
    deleteTicket: (ticketId: number, params: RequestParams = {}) =>
      this.request<boolean, MessageResponse>({
        path: `/api/tickets/${ticketId}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name CreateUser
     * @request POST:/api/users
     */
    createUser: (data: CreateUserDto, params: RequestParams = {}) =>
      this.request<UserDto, MessageResponse>({
        path: `/api/users`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name GetAllUsers
     * @request GET:/api/users
     */
    getAllUsers: (
      query: {
        /** @format int32 */
        Limit: number;
        /** @format int32 */
        Offset: number;
        FilterQuery: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<UserDtoLazyResponse, any>({
        path: `/api/users`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UpdateUser
     * @request PUT:/api/users/{userId}
     */
    updateUser: (userId: number, data: UpdateUserDto, params: RequestParams = {}) =>
      this.request<UserDto, MessageResponse>({
        path: `/api/users/${userId}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name GetUserById
     * @request GET:/api/users/{userId}
     */
    getUserById: (userId: number, params: RequestParams = {}) =>
      this.request<UserDto, MessageResponse>({
        path: `/api/users/${userId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name DeleteUser
     * @request DELETE:/api/users/{userId}
     */
    deleteUser: (userId: number, params: RequestParams = {}) =>
      this.request<boolean, MessageResponse>({
        path: `/api/users/${userId}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name GetBrokerUserById
     * @request GET:/api/users/broker/{userId}
     */
    getBrokerUserById: (userId: number, params: RequestParams = {}) =>
      this.request<BrokerUserDto, MessageResponse>({
        path: `/api/users/broker/${userId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name GetAllUserRoles
     * @request GET:/api/users/roles
     */
    getAllUserRoles: (params: RequestParams = {}) =>
      this.request<DropdownItem[], any>({
        path: `/api/users/roles`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  hubs = {
    /**
     * No description
     *
     * @tags OnlineSessionHub
     * @name OnlineSessionHubErrorCreate
     * @request POST:/hubs/OnlineSessionHub/Error
     */
    onlineSessionHubErrorCreate: (
      query?: {
        error?: SignalRError;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/hubs/OnlineSessionHub/Error`,
        method: "POST",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags OnlineSessionHub
     * @name OnlineSessionHubReceiveDealCreate
     * @request POST:/hubs/OnlineSessionHub/ReceiveDeal
     */
    onlineSessionHubReceiveDealCreate: (
      query?: {
        sessionDealDto?: SessionDealDto;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/hubs/OnlineSessionHub/ReceiveDeal`,
        method: "POST",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags OnlineSessionHub
     * @name OnlineSessionHubReceiveLiveSessionInfoCreate
     * @request POST:/hubs/OnlineSessionHub/ReceiveLiveSessionInfo
     */
    onlineSessionHubReceiveLiveSessionInfoCreate: (
      query?: {
        onlineSessionStateDto?: OnlineSessionStateDto;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/hubs/OnlineSessionHub/ReceiveLiveSessionInfo`,
        method: "POST",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags OnlineSessionHub
     * @name OnlineSessionHubReceiveOnlineSessionEventCreate
     * @request POST:/hubs/OnlineSessionHub/ReceiveOnlineSessionEvent
     */
    onlineSessionHubReceiveOnlineSessionEventCreate: (
      query?: {
        event?: OnlineSessionEventEntity;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/hubs/OnlineSessionHub/ReceiveOnlineSessionEvent`,
        method: "POST",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags OnlineSessionHub
     * @name OnlineSessionHubReceiveCountdownCreate
     * @request POST:/hubs/OnlineSessionHub/ReceiveCountdown
     */
    onlineSessionHubReceiveCountdownCreate: (
      query?: {
        onlineSessionSyncDto?: OnlineSessionSyncDto;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/hubs/OnlineSessionHub/ReceiveCountdown`,
        method: "POST",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags OnlineSessionHub
     * @name OnlineSessionHubReceiveAllowedBrokersForCurrentOfferCreate
     * @request POST:/hubs/OnlineSessionHub/ReceiveAllowedBrokersForCurrentOffer
     */
    onlineSessionHubReceiveAllowedBrokersForCurrentOfferCreate: (
      query?: {
        allowedBrokers?: number[];
      },
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/hubs/OnlineSessionHub/ReceiveAllowedBrokersForCurrentOffer`,
        method: "POST",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags SessionScreenHub
     * @name SessionScreenHubDataCreate
     * @request POST:/hubs/SessionScreenHub/Data
     */
    sessionScreenHubDataCreate: (
      query?: {
        sessionScreenDto?: SessionScreenDto;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/hubs/SessionScreenHub/Data`,
        method: "POST",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags SessionScreenHub
     * @name SessionScreenHubDealCreate
     * @request POST:/hubs/SessionScreenHub/Deal
     */
    sessionScreenHubDealCreate: (
      query?: {
        dealDto?: SessionDealDto;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/hubs/SessionScreenHub/Deal`,
        method: "POST",
        query: query,
        ...params,
      }),
  };
}
